/*
 * @Author: Yolo
 * @Date: 2024-07-16 10:55:07
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-07-16 11:10:29
 * @Desc 渔区边界
 */
import L from 'leaflet'
import { throttle } from 'lodash-unified'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import { AreaViewBase } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import type { LatLng, Polygon } from 'leaflet'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
import type { AreaViewBaseOptions } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
interface FisheryData {
  lat: number
  lon: number
  id: string
  name: string
}

let lyGroup: any

class FisheryManagerSymbol extends AreaViewBase {
  private dispose = false
  private span: { x: number; y: number } = { x: 0.5, y: 0.5 }
  private isInit = false

  private layerHash: Record<string, Polygon> = {}
  private layerHashName: Record<string, L.Polygon> = {}

  private data: FisheryData[] = [
    { id: '001', lat: 40.75, lon: 120.75, name: '渤海' },
    { id: '002', lat: 40.75, lon: 121.25, name: '渤海' },
    { id: '003', lat: 40.75, lon: 121.75, name: '渤海' },
    { id: '004', lat: 40.75, lon: 122.25, name: '渤海' },
    { id: '005', lat: 40.25, lon: 120.25, name: '渤海' },
    { id: '006', lat: 40.25, lon: 120.75, name: '渤海' },
    { id: '007', lat: 40.25, lon: 121.25, name: '渤海' },
    { id: '008', lat: 40.25, lon: 121.75, name: '渤海' },
    { id: '009', lat: 40.25, lon: 122.25, name: '渤海' },
    { id: '010', lat: 39.75, lon: 119.25, name: '渤海' },
    { id: '011', lat: 39.75, lon: 119.75, name: '渤海' },
    { id: '012', lat: 39.75, lon: 120.25, name: '渤海' },
    { id: '013', lat: 39.75, lon: 120.75, name: '渤海' },
    { id: '014', lat: 39.75, lon: 121.25, name: '渤海' },
    { id: '015', lat: 39.75, lon: 121.75, name: '渤海' },
    { id: '016', lat: 39.75, lon: 122.75, name: '黄海北部' },
    { id: '017', lat: 39.75, lon: 123.25, name: '黄海北部' },
    { id: '018', lat: 39.75, lon: 123.75, name: '黄海北部' },
    { id: '019', lat: 39.75, lon: 124.25, name: '黄海北部' },
    { id: '020', lat: 39.25, lon: 117.75, name: '渤海' },
    { id: '021', lat: 39.25, lon: 118.25, name: '渤海' },
    { id: '022', lat: 39.25, lon: 118.75, name: '渤海' },
    { id: '023', lat: 39.25, lon: 119.25, name: '渤海' },
    { id: '024', lat: 39.25, lon: 119.75, name: '渤海' },
    { id: '025', lat: 39.25, lon: 120.25, name: '渤海' },
    { id: '026', lat: 39.25, lon: 120.75, name: '渤海' },
    { id: '027', lat: 39.25, lon: 121.25, name: '渤海' },
    { id: '028', lat: 39.25, lon: 121.75, name: '渤海' },
    { id: '029', lat: 39.25, lon: 122.25, name: '黄海北部' },
    { id: '030', lat: 39.25, lon: 122.75, name: '黄海北部' },
    { id: '031', lat: 39.25, lon: 123.25, name: '黄海北部' },
    { id: '032', lat: 39.25, lon: 123.75, name: '黄海北部' },
    { id: '033', lat: 39.25, lon: 124.25, name: '黄海北部' },
    { id: '034', lat: 38.75, lon: 117.75, name: '渤海' },
    { id: '035', lat: 38.75, lon: 118.25, name: '渤海' },
    { id: '036', lat: 38.75, lon: 118.75, name: '渤海' },
    { id: '037', lat: 38.75, lon: 119.25, name: '渤海' },
    { id: '038', lat: 38.75, lon: 119.75, name: '渤海' },
    { id: '039', lat: 38.75, lon: 120.25, name: '渤海' },
    { id: '040', lat: 38.75, lon: 120.75, name: '渤海' },
    { id: '041', lat: 38.75, lon: 121.25, name: '渤海' },
    { id: '042', lat: 38.75, lon: 121.75, name: '黄海北部' },
    { id: '043', lat: 38.75, lon: 122.25, name: '黄海北部' },
    { id: '044', lat: 38.75, lon: 122.75, name: '黄海北部' },
    { id: '045', lat: 38.75, lon: 123.25, name: '黄海北部' },
    { id: '046', lat: 38.75, lon: 123.75, name: '黄海北部' },
    { id: '047', lat: 38.25, lon: 117.75, name: '渤海' },
    { id: '048', lat: 38.25, lon: 118.25, name: '渤海' },
    { id: '049', lat: 38.25, lon: 118.75, name: '渤海' },
    { id: '050', lat: 38.25, lon: 119.25, name: '渤海' },
    { id: '051', lat: 38.25, lon: 119.75, name: '渤海' },
    { id: '052', lat: 38.25, lon: 120.25, name: '渤海' },
    { id: '053', lat: 38.25, lon: 120.75, name: '渤海' },
    { id: '054', lat: 38.25, lon: 121.25, name: '渤海' },
    { id: '055', lat: 38.25, lon: 121.75, name: '黄海北部' },
    { id: '056', lat: 38.25, lon: 122.25, name: '黄海北部' },
    { id: '057', lat: 38.25, lon: 122.75, name: '黄海北部' },
    { id: '058', lat: 38.25, lon: 123.25, name: '黄海北部' },
    { id: '059', lat: 38.25, lon: 123.75, name: '黄海北部' },
    { id: '060', lat: 37.75, lon: 118.75, name: '渤海' },
    { id: '061', lat: 37.75, lon: 119.25, name: '渤海' },
    { id: '062', lat: 37.75, lon: 119.75, name: '渤海' },
    { id: '063', lat: 37.75, lon: 120.25, name: '渤海' },
    { id: '064', lat: 37.75, lon: 120.75, name: '渤海' },
    { id: '065', lat: 37.75, lon: 121.25, name: '黄海北部' },
    { id: '066', lat: 37.75, lon: 121.75, name: '黄海北部' },
    { id: '067', lat: 37.75, lon: 122.25, name: '黄海北部' },
    { id: '068', lat: 37.75, lon: 122.75, name: '黄海北部' },
    { id: '069', lat: 37.75, lon: 123.25, name: '黄海北部' },
    { id: '070', lat: 37.75, lon: 123.75, name: '黄海北部' },
    { id: '071', lat: 37.25, lon: 118.75, name: '渤海' },
    { id: '072', lat: 37.25, lon: 119.25, name: '渤海' },
    { id: '073', lat: 37.25, lon: 119.75, name: '渤海' },
    { id: '074', lat: 37.25, lon: 122.75, name: '黄海北部' },
    { id: '075', lat: 37.25, lon: 123.25, name: '黄海北部' },
    { id: '076', lat: 37.25, lon: 123.75, name: '黄海北部' },
    { id: '077', lat: 36.75, lon: 121.25, name: '黄海中部' },
    { id: '078', lat: 36.75, lon: 121.75, name: '黄海中部' },
    { id: '079', lat: 36.75, lon: 122.25, name: '黄海中部' },
    { id: '080', lat: 36.75, lon: 122.75, name: '黄海中部' },
    { id: '081', lat: 36.75, lon: 123.25, name: '黄海中部' },
    { id: '082', lat: 36.75, lon: 123.75, name: '黄海中部' },
    { id: '083', lat: 36.25, lon: 120.75, name: '黄海中部' },
    { id: '084', lat: 36.25, lon: 121.25, name: '黄海中部' },
    { id: '085', lat: 36.25, lon: 121.75, name: '黄海中部' },
    { id: '086', lat: 36.25, lon: 122.25, name: '黄海中部' },
    { id: '087', lat: 36.25, lon: 122.75, name: '黄海中部' },
    { id: '088', lat: 36.25, lon: 123.25, name: '黄海中部' },
    { id: '089', lat: 36.25, lon: 123.75, name: '黄海中部' },
    { id: '090', lat: 35.75, lon: 119.75, name: '黄海中部' },
    { id: '091', lat: 35.75, lon: 120.25, name: '黄海中部' },
    { id: '092', lat: 35.75, lon: 120.75, name: '黄海中部' },
    { id: '093', lat: 35.75, lon: 121.25, name: '黄海中部' },
    { id: '094', lat: 35.75, lon: 121.75, name: '黄海中部' },
    { id: '095', lat: 35.75, lon: 122.25, name: '黄海中部' },
    { id: '096', lat: 35.75, lon: 122.75, name: '黄海中部' },
    { id: '097', lat: 35.75, lon: 123.25, name: '黄海中部' },
    { id: '098', lat: 35.75, lon: 123.75, name: '黄海中部' },
    { id: '099', lat: 35.25, lon: 119.25, name: '黄海中部' },
    { id: '100', lat: 35.25, lon: 119.75, name: '黄海中部' },
    { id: '101', lat: 35.25, lon: 120.25, name: '黄海中部' },
    { id: '102', lat: 35.25, lon: 120.75, name: '黄海中部' },
    { id: '103', lat: 35.25, lon: 121.25, name: '黄海中部' },
    { id: '104', lat: 35.25, lon: 121.75, name: '黄海中部' },
    { id: '105', lat: 35.25, lon: 122.25, name: '黄海中部' },
    { id: '106', lat: 35.25, lon: 122.75, name: '黄海中部' },
    { id: '107', lat: 35.25, lon: 123.25, name: '黄海中部' },
    { id: '108', lat: 35.25, lon: 123.75, name: '黄海中部' },
    { id: '109', lat: 34.75, lon: 119.25, name: '黄海南部' },
    { id: '110', lat: 34.75, lon: 119.75, name: '黄海南部' },
    { id: '111', lat: 34.75, lon: 120.25, name: '黄海南部' },
    { id: '112', lat: 34.75, lon: 120.75, name: '滨海近岸海域' },
    { id: '113', lat: 34.75, lon: 121.25, name: '黄海南部' },
    { id: '114', lat: 34.75, lon: 121.75, name: '黄海南部' },
    { id: '115', lat: 34.75, lon: 122.25, name: '黄海南部' },
    { id: '116', lat: 34.75, lon: 122.75, name: '黄海南部' },
    { id: '117', lat: 34.75, lon: 123.25, name: '黄海南部' },
    { id: '118', lat: 34.75, lon: 123.75, name: '黄海南部' },
    { id: '119', lat: 34.25, lon: 120.25, name: '响水近岸海域' },
    { id: '120', lat: 34.25, lon: 120.75, name: '滨海近岸海域' },
    { id: '121', lat: 34.25, lon: 121.25, name: '射阳近岸海域' },
    { id: '122', lat: 34.25, lon: 121.75, name: '黄海南部' },
    { id: '123', lat: 34.25, lon: 122.25, name: '黄海南部' },
    { id: '124', lat: 34.25, lon: 122.75, name: '黄海南部' },
    { id: '125', lat: 34.25, lon: 123.25, name: '黄海南部' },
    { id: '126', lat: 34.25, lon: 123.75, name: '黄海南部' },
    { id: '127', lat: 33.75, lon: 120.75, name: '射阳近岸海域' },
    { id: '128', lat: 33.75, lon: 121.25, name: '射阳近岸海域' },
    { id: '129', lat: 33.75, lon: 121.75, name: '亭湖近岸海域' },
    { id: '130', lat: 33.75, lon: 122.25, name: '黄海南部' },
    { id: '131', lat: 33.75, lon: 122.75, name: '黄海南部' },
    { id: '132', lat: 33.75, lon: 123.25, name: '黄海南部' },
    { id: '133', lat: 33.75, lon: 123.75, name: '黄海南部' },
    { id: '134', lat: 33.75, lon: 124.25, name: '黄海南部' },
    { id: '135', lat: 33.75, lon: 124.75, name: '黄海南部' },
    { id: '136', lat: 33.25, lon: 120.75, name: '亭湖近岸海域' },
    { id: '137', lat: 33.25, lon: 121.25, name: '亭湖近岸海域' },
    { id: '138', lat: 33.25, lon: 121.75, name: '亭湖近岸海域' },
    { id: '139', lat: 33.25, lon: 122.25, name: '黄海南部' },
    { id: '140', lat: 33.25, lon: 122.75, name: '黄海南部' },
    { id: '141', lat: 33.25, lon: 123.25, name: '黄海南部' },
    { id: '142', lat: 33.25, lon: 123.75, name: '黄海南部' },
    { id: '143', lat: 33.25, lon: 124.25, name: '黄海南部' },
    { id: '144', lat: 33.25, lon: 124.75, name: '黄海南部' },
    { id: '145', lat: 32.75, lon: 121.25, name: '东台近岸海域' },
    { id: '146', lat: 32.75, lon: 121.75, name: '东台近岸海域' },
    { id: '147', lat: 32.75, lon: 122.25, name: '如东近岸海域' },
    { id: '148', lat: 32.75, lon: 122.75, name: '黄海南部' },
    { id: '149', lat: 32.75, lon: 123.25, name: '黄海南部' },
    { id: '150', lat: 32.75, lon: 123.75, name: '黄海南部' },
    { id: '151', lat: 32.75, lon: 124.25, name: '黄海南部' },
    { id: '152', lat: 32.75, lon: 124.75, name: '黄海南部' },
    { id: '153', lat: 32.25, lon: 121.75, name: '启东近岸海域' },
    { id: '154', lat: 32.25, lon: 122.25, name: '启东近岸海域' },
    { id: '155', lat: 32.25, lon: 122.75, name: '东海西北部' },
    { id: '156', lat: 32.25, lon: 123.25, name: '东海西北部' },
    { id: '157', lat: 32.25, lon: 123.75, name: '东海西北部' },
    { id: '158', lat: 32.25, lon: 124.25, name: '东海西北部' },
    { id: '159', lat: 32.25, lon: 124.75, name: '东海西北部' },
    { id: '160', lat: 31.75, lon: 121.75, name: '启东近岸海域' },
    { id: '161', lat: 31.75, lon: 122.25, name: '启东近岸海域' },
    { id: '162', lat: 31.75, lon: 122.75, name: '东海西北部' },
    { id: '163', lat: 31.75, lon: 123.25, name: '东海西北部' },
    { id: '164', lat: 31.75, lon: 123.75, name: '东海西北部' },
    { id: '165', lat: 31.75, lon: 124.25, name: '东海西北部' },
    { id: '166', lat: 31.75, lon: 124.75, name: '东海西北部' },
    { id: '167', lat: 31.25, lon: 121.75, name: '浦东近岸海域' },
    { id: '168', lat: 31.25, lon: 122.25, name: '浦东近岸海域' },
    { id: '169', lat: 31.25, lon: 122.75, name: '长江口外近岸海域' },
    { id: '170', lat: 31.25, lon: 123.25, name: '长江口外近岸海域' },
    { id: '171', lat: 31.25, lon: 123.75, name: '东海西北部' },
    { id: '172', lat: 31.25, lon: 124.25, name: '东海西北部' },
    { id: '173', lat: 31.25, lon: 124.75, name: '东海西北部' },
    { id: '174', lat: 30.75, lon: 121.25, name: '奉贤近岸海域' },
    { id: '175', lat: 30.75, lon: 121.75, name: '浦东近岸海域' },
    { id: '176', lat: 30.75, lon: 122.25, name: '崇明近岸海域' },
    { id: '177', lat: 30.75, lon: 122.75, name: '长江口外近岸海域' },
    { id: '178', lat: 30.75, lon: 123.25, name: '长江口外近岸海域' },
    { id: '179', lat: 30.75, lon: 123.75, name: '东海西北部' },
    { id: '180', lat: 30.75, lon: 124.25, name: '东海西北部' },
    { id: '181', lat: 30.75, lon: 124.75, name: '东海西北部' },
    { id: '182', lat: 30.25, lon: 121.25, name: '平湖近岸海域' },
    { id: '183', lat: 30.25, lon: 121.75, name: '洋山近岸海域' },
    { id: '184', lat: 30.25, lon: 122.25, name: '洋山近岸海域' },
    { id: '185', lat: 30.25, lon: 122.75, name: '岱山近岸海域' },
    { id: '186', lat: 30.25, lon: 123.25, name: '嵊山近岸海域' },
    { id: '187', lat: 30.25, lon: 123.75, name: '东海西北部' },
    { id: '188', lat: 30.25, lon: 124.25, name: '东海西北部' },
    { id: '189', lat: 30.25, lon: 124.75, name: '东海西北部' },
    { id: '190', lat: 29.75, lon: 122.25, name: '北仑北部近岸海域' },
    { id: '191', lat: 29.75, lon: 122.75, name: '普陀近岸海域' },
    { id: '192', lat: 29.75, lon: 123.25, name: '东极近岸海域' },
    { id: '193', lat: 29.75, lon: 123.75, name: '东海西北部' },
    { id: '194', lat: 29.75, lon: 124.25, name: '东海西北部' },
    { id: '195', lat: 29.75, lon: 124.75, name: '东海西北部' },
    { id: '196', lat: 29.25, lon: 122.25, name: '象山东部近岸海域' },
    { id: '197', lat: 29.25, lon: 122.75, name: '象山东部近岸海域' },
    { id: '198', lat: 29.25, lon: 123.25, name: '东海西南部' },
    { id: '199', lat: 29.25, lon: 123.75, name: '东海西南部' },
    { id: '200', lat: 29.25, lon: 124.25, name: '东海西南部' },
    { id: '201', lat: 29.25, lon: 124.75, name: '东海西南部' },
    { id: '202', lat: 28.75, lon: 121.75, name: '象山南部近岸海域' },
    { id: '203', lat: 28.75, lon: 122.25, name: '象山东部近岸海域' },
    { id: '204', lat: 28.75, lon: 122.75, name: '象山东部近岸海域' },
    { id: '205', lat: 28.75, lon: 123.25, name: '东海西南部' },
    { id: '206', lat: 28.75, lon: 123.75, name: '东海西南部' },
    { id: '207', lat: 28.75, lon: 124.25, name: '东海西南部' },
    { id: '208', lat: 28.75, lon: 124.75, name: '东海西南部' },
    { id: '209', lat: 28.25, lon: 121.25, name: '温岭近岸海域' },
    { id: '210', lat: 28.25, lon: 121.75, name: '椒江近岸海域' },
    { id: '211', lat: 28.25, lon: 122.25, name: '大陈近岸海域' },
    { id: '212', lat: 28.25, lon: 122.75, name: '东海西南部' },
    { id: '213', lat: 28.25, lon: 123.25, name: '东海西南部' },
    { id: '214', lat: 28.25, lon: 123.75, name: '东海西南部' },
    { id: '215', lat: 28.25, lon: 124.25, name: '东海西南部' },
    { id: '216', lat: 28.25, lon: 124.75, name: '东海西南部' },
    { id: '217', lat: 27.75, lon: 120.75, name: '乐清湾' },
    { id: '218', lat: 27.75, lon: 121.25, name: '玉环近岸海域' },
    { id: '219', lat: 27.75, lon: 121.75, name: '玉环近岸海域' },
    { id: '220', lat: 27.75, lon: 122.25, name: '东海西南部' },
    { id: '221', lat: 27.75, lon: 122.75, name: '东海西南部' },
    { id: '222', lat: 27.75, lon: 123.25, name: '东海西南部' },
    { id: '223', lat: 27.75, lon: 123.75, name: '东海西南部' },
    { id: '224', lat: 27.75, lon: 124.25, name: '东海西南部' },
    { id: '225', lat: 27.75, lon: 124.75, name: '东海西南部' },
    { id: '226', lat: 27.25, lon: 120.75, name: '福鼎近岸海域' },
    { id: '227', lat: 27.25, lon: 121.25, name: '台山列岛近岸海域' },
    { id: '228', lat: 27.25, lon: 121.75, name: '东海西南部' },
    { id: '229', lat: 27.25, lon: 122.25, name: '东海西南部' },
    { id: '230', lat: 27.25, lon: 122.75, name: '东海西南部' },
    { id: '231', lat: 27.25, lon: 123.25, name: '东海西南部' },
    { id: '232', lat: 27.25, lon: 123.75, name: '东海西南部' },
    { id: '233', lat: 27.25, lon: 124.25, name: '东海西南部' },
    { id: '234', lat: 27.25, lon: 124.75, name: '台湾以东洋面' },
    { id: '235', lat: 26.75, lon: 120.25, name: '福鼎近岸海域' },
    { id: '236', lat: 26.75, lon: 120.75, name: '台山列岛近岸海域' },
    { id: '237', lat: 26.75, lon: 121.25, name: '台山列岛近岸海域' },
    { id: '238', lat: 26.75, lon: 121.75, name: '东海西南部' },
    { id: '239', lat: 26.75, lon: 122.25, name: '东海西南部' },
    { id: '240', lat: 26.75, lon: 122.75, name: '东海西南部' },
    { id: '241', lat: 26.75, lon: 123.25, name: '东海西南部' },
    { id: '242', lat: 26.75, lon: 123.75, name: '东海西南部' },
    { id: '243', lat: 26.75, lon: 124.25, name: '台湾以东洋面' },
    { id: '244', lat: 26.25, lon: 119.75, name: '西洋浮鹰近岸海域' },
    { id: '245', lat: 26.25, lon: 120.25, name: '西洋浮鹰近岸海域' },
    { id: '246', lat: 26.25, lon: 120.75, name: '西洋浮鹰近岸海域' },
    { id: '247', lat: 26.25, lon: 121.25, name: '东海西南部' },
    { id: '248', lat: 26.25, lon: 121.75, name: '东海西南部' },
    { id: '249', lat: 26.25, lon: 122.25, name: '东海西南部' },
    { id: '250', lat: 26.25, lon: 122.75, name: '东海西南部' },
    { id: '251', lat: 26.25, lon: 123.25, name: '东海西南部' },
    { id: '252', lat: 26.25, lon: 123.75, name: '台湾以东洋面' },
    { id: '253', lat: 26.25, lon: 124.25, name: '台湾以东洋面' },
    { id: '254', lat: 25.75, lon: 119.75, name: '长乐近岸海域' },
    { id: '255', lat: 25.75, lon: 120.25, name: '长乐近岸海域' },
    { id: '256', lat: 25.75, lon: 120.75, name: '台湾海峡' },
    { id: '257', lat: 25.75, lon: 121.25, name: '东海西南部' },
    { id: '258', lat: 25.75, lon: 121.75, name: '东海西南部' },
    { id: '259', lat: 25.75, lon: 122.25, name: '东海西南部' },
    { id: '260', lat: 25.75, lon: 122.75, name: '东海西南部' },
    { id: '261', lat: 25.75, lon: 123.25, name: '台湾以东洋面' },
    { id: '262', lat: 25.75, lon: 123.75, name: '台湾以东洋面' },
    { id: '263', lat: 25.25, lon: 119.25, name: '兴化湾' },
    { id: '264', lat: 25.25, lon: 119.75, name: '兴化湾' },
    { id: '265', lat: 25.25, lon: 120.25, name: '平潭近岸海域' },
    { id: '266', lat: 25.25, lon: 120.75, name: '台湾海峡' },
    { id: '267', lat: 25.25, lon: 121.25, name: '东海西南部' },
    { id: '268', lat: 25.25, lon: 121.75, name: '东海西南部' },
    { id: '269', lat: 25.25, lon: 122.25, name: '台湾以东洋面' },
    { id: '270', lat: 25.25, lon: 122.75, name: '台湾以东洋面' },
    { id: '271', lat: 25.25, lon: 123.25, name: '台湾以东洋面' },
    { id: '272', lat: 25.25, lon: 123.75, name: '台湾以东洋面' },
    { id: '273', lat: 24.75, lon: 118.75, name: '惠安县近岸海域' },
    { id: '274', lat: 24.75, lon: 119.25, name: '秀屿区近岸海域' },
    { id: '275', lat: 24.75, lon: 119.75, name: '秀屿区近岸海域' },
    { id: '276', lat: 24.75, lon: 120.25, name: '台湾海峡' },
    { id: '277', lat: 24.75, lon: 120.75, name: '台湾海峡' },
    { id: '278', lat: 24.75, lon: 121.75, name: '台湾以东洋面' },
    { id: '279', lat: 24.75, lon: 122.25, name: '台湾以东洋面' },
    { id: '280', lat: 24.75, lon: 122.75, name: '台湾以东洋面' },
    { id: '281', lat: 24.75, lon: 123.25, name: '台湾以东洋面' },
    { id: '282', lat: 24.25, lon: 118.25, name: '厦门近岸海域' },
    { id: '283', lat: 24.25, lon: 118.75, name: '金门近海海域' },
    { id: '284', lat: 24.25, lon: 119.25, name: '石狮市近岸海域' },
    { id: '285', lat: 24.25, lon: 119.75, name: '台湾海峡' },
    { id: '286', lat: 24.25, lon: 120.25, name: '台湾海峡' },
    { id: '287', lat: 24.25, lon: 121.75, name: '台湾以东洋面' },
    { id: '288', lat: 24.25, lon: 122.25, name: '台湾以东洋面' },
    { id: '289', lat: 24.25, lon: 122.75, name: '台湾以东洋面' },
    { id: '290', lat: 24.25, lon: 123.25, name: '台湾以东洋面' },
    { id: '291', lat: 23.75, lon: 117.75, name: '东山湾' },
    { id: '292', lat: 23.75, lon: 118.25, name: '龙海市近岸海域' },
    { id: '293', lat: 23.75, lon: 118.75, name: '台湾海峡' },
    { id: '294', lat: 23.75, lon: 119.25, name: '台湾海峡' },
    { id: '295', lat: 23.75, lon: 119.75, name: '台湾海峡' },
    { id: '296', lat: 23.75, lon: 120.25, name: '台湾海峡' },
    { id: '297', lat: 23.75, lon: 121.75, name: '台湾以东洋面' },
    { id: '298', lat: 23.75, lon: 122.25, name: '台湾以东洋面' },
    { id: '299', lat: 23.75, lon: 122.75, name: '台湾以东洋面' },
    { id: '300', lat: 23.25, lon: 116.75, name: '南海东北部' },
    { id: '301', lat: 23.25, lon: 117.25, name: '诏安县近岸海域' },
    { id: '302', lat: 23.25, lon: 117.75, name: '东山县近岸海域' },
    { id: '303', lat: 23.25, lon: 118.25, name: '台湾海峡' },
    { id: '304', lat: 23.25, lon: 118.75, name: '台湾海峡' },
    { id: '305', lat: 23.25, lon: 119.25, name: '台湾海峡' },
    { id: '306', lat: 23.25, lon: 119.75, name: '台湾海峡' },
    { id: '307', lat: 23.25, lon: 121.75, name: '台湾以东洋面' },
    { id: '308', lat: 23.25, lon: 122.25, name: '台湾以东洋面' },
    { id: '309', lat: 23.25, lon: 122.75, name: '台湾以东洋面' },
    { id: '310', lat: 22.75, lon: 115.25, name: '南海东北部' },
    { id: '311', lat: 22.75, lon: 115.75, name: '南海东北部' },
    { id: '312', lat: 22.75, lon: 116.25, name: '南海东北部' },
    { id: '313', lat: 22.75, lon: 116.75, name: '南海东北部' },
    { id: '314', lat: 22.75, lon: 117.25, name: '南海东北部' },
    { id: '315', lat: 22.75, lon: 117.75, name: '南海东北部' },
    { id: '316', lat: 22.75, lon: 118.25, name: '台湾海峡' },
    { id: '317', lat: 22.75, lon: 118.75, name: '台湾海峡' },
    { id: '318', lat: 22.75, lon: 119.25, name: '台湾海峡' },
    { id: '319', lat: 22.75, lon: 119.75, name: '台湾海峡' },
    { id: '320', lat: 22.75, lon: 120.25, name: '台湾海峡' },
    { id: '321', lat: 22.75, lon: 121.25, name: '台湾以东洋面' },
    { id: '322', lat: 22.75, lon: 121.75, name: '台湾以东洋面' },
    { id: '323', lat: 22.75, lon: 122.25, name: '台湾以东洋面' },
    { id: '324', lat: 22.25, lon: 113.75, name: '南海西北部' },
    { id: '325', lat: 22.25, lon: 114.25, name: '南海西北部' },
    { id: '326', lat: 22.25, lon: 114.75, name: '南海东北部' },
    { id: '327', lat: 22.25, lon: 115.25, name: '南海东北部' },
    { id: '328', lat: 22.25, lon: 115.75, name: '南海东北部' },
    { id: '329', lat: 22.25, lon: 116.25, name: '南海东北部' },
    { id: '330', lat: 22.25, lon: 116.75, name: '南海东北部' },
    { id: '331', lat: 22.25, lon: 117.25, name: '南海东北部' },
    { id: '332', lat: 22.25, lon: 117.75, name: '南海东北部' },
    { id: '333', lat: 22.25, lon: 118.25, name: '南海东北部' },
    { id: '334', lat: 22.25, lon: 118.75, name: '南海东北部' },
    { id: '335', lat: 22.25, lon: 119.25, name: '台湾海峡' },
    { id: '336', lat: 22.25, lon: 119.75, name: '台湾海峡' },
    { id: '337', lat: 22.25, lon: 120.25, name: '台湾海峡' },
    { id: '338', lat: 22.25, lon: 121.25, name: '台湾以东洋面' },
    { id: '339', lat: 22.25, lon: 121.75, name: '台湾以东洋面' },
    { id: '340', lat: 22.25, lon: 122.25, name: '台湾以东洋面' },
    { id: '341', lat: 21.75, lon: 112.25, name: '南海西北部' },
    { id: '342', lat: 21.75, lon: 112.75, name: '南海西北部' },
    { id: '343', lat: 21.75, lon: 113.25, name: '南海西北部' },
    { id: '344', lat: 21.75, lon: 113.75, name: '南海西北部' },
    { id: '345', lat: 21.75, lon: 114.25, name: '南海西北部' },
    { id: '346', lat: 21.75, lon: 114.75, name: '南海东北部' },
    { id: '347', lat: 21.75, lon: 115.25, name: '南海东北部' },
    { id: '348', lat: 21.75, lon: 115.75, name: '南海东北部' },
    { id: '349', lat: 21.75, lon: 116.25, name: '南海东北部' },
    { id: '350', lat: 21.75, lon: 116.75, name: '南海东北部' },
    { id: '351', lat: 21.75, lon: 117.25, name: '南海东北部' },
    { id: '352', lat: 21.75, lon: 117.75, name: '南海东北部' },
    { id: '353', lat: 21.75, lon: 118.25, name: '南海东北部' },
    { id: '354', lat: 21.75, lon: 118.75, name: '南海东北部' },
    { id: '355', lat: 21.75, lon: 119.25, name: '南海东北部' },
    { id: '356', lat: 21.75, lon: 119.75, name: '台湾海峡' },
    { id: '357', lat: 21.75, lon: 120.25, name: '台湾海峡' },
    { id: '358', lat: 21.75, lon: 120.75, name: '台湾海峡' },
    { id: '359', lat: 21.75, lon: 121.25, name: '台湾以东洋面' },
    { id: '360', lat: 21.75, lon: 121.75, name: '台湾以东洋面' },
    { id: '361', lat: 21.25, lon: 108.25, name: '北部湾' },
    { id: '362', lat: 21.25, lon: 108.75, name: '北部湾' },
    { id: '363', lat: 21.25, lon: 109.25, name: '北部湾' },
    { id: '364', lat: 21.25, lon: 109.75, name: '北部湾' },
    { id: '365', lat: 21.25, lon: 110.75, name: '南海西北部' },
    { id: '366', lat: 21.25, lon: 111.25, name: '南海西北部' },
    { id: '367', lat: 21.25, lon: 111.75, name: '南海西北部' },
    { id: '368', lat: 21.25, lon: 112.25, name: '南海西北部' },
    { id: '369', lat: 21.25, lon: 112.75, name: '南海西北部' },
    { id: '370', lat: 21.25, lon: 113.25, name: '南海西北部' },
    { id: '371', lat: 21.25, lon: 113.75, name: '南海西北部' },
    { id: '372', lat: 21.25, lon: 114.25, name: '南海西北部' },
    { id: '373', lat: 21.25, lon: 114.75, name: '南海东北部' },
    { id: '374', lat: 21.25, lon: 115.25, name: '南海东北部' },
    { id: '375', lat: 21.25, lon: 115.75, name: '南海东北部' },
    { id: '376', lat: 21.25, lon: 116.25, name: '南海东北部' },
    { id: '377', lat: 21.25, lon: 116.75, name: '南海东北部' },
    { id: '378', lat: 21.25, lon: 117.25, name: '南海东北部' },
    { id: '379', lat: 21.25, lon: 117.75, name: '南海东北部' },
    { id: '380', lat: 21.25, lon: 118.25, name: '南海东北部' },
    { id: '381', lat: 21.25, lon: 118.75, name: '南海东北部' },
    { id: '382', lat: 21.25, lon: 119.25, name: '南海东北部' },
    { id: '383', lat: 21.25, lon: 119.75, name: '南海东北部' },
    { id: '384', lat: 21.25, lon: 120.25, name: '南海东北部' },
    { id: '385', lat: 21.25, lon: 120.75, name: '巴士海峡' },
    { id: '386', lat: 20.75, lon: 107.25, name: '北部湾' },
    { id: '387', lat: 20.75, lon: 107.75, name: '北部湾' },
    { id: '388', lat: 20.75, lon: 108.25, name: '北部湾' },
    { id: '389', lat: 20.75, lon: 108.75, name: '北部湾' },
    { id: '390', lat: 20.75, lon: 109.25, name: '北部湾' },
    { id: '391', lat: 20.75, lon: 109.75, name: '北部湾' },
    { id: '392', lat: 20.75, lon: 110.25, name: '南海西北部' },
    { id: '393', lat: 20.75, lon: 110.75, name: '南海西北部' },
    { id: '394', lat: 20.75, lon: 111.25, name: '南海西北部' },
    { id: '395', lat: 20.75, lon: 111.75, name: '南海西北部' },
    { id: '396', lat: 20.75, lon: 112.25, name: '南海西北部' },
    { id: '397', lat: 20.75, lon: 112.75, name: '南海西北部' },
    { id: '398', lat: 20.75, lon: 113.25, name: '南海西北部' },
    { id: '399', lat: 20.75, lon: 113.75, name: '南海西北部' },
    { id: '400', lat: 20.75, lon: 114.25, name: '南海西北部' },
    { id: '401', lat: 20.75, lon: 114.75, name: '南海东北部' },
    { id: '402', lat: 20.75, lon: 115.25, name: '南海东北部' },
    { id: '403', lat: 20.75, lon: 115.75, name: '南海东北部' },
    { id: '404', lat: 20.75, lon: 116.25, name: '南海东北部' },
    { id: '405', lat: 20.75, lon: 116.75, name: '南海东北部' },
    { id: '406', lat: 20.75, lon: 117.25, name: '南海东北部' },
    { id: '407', lat: 20.75, lon: 117.75, name: '南海东北部' },
    { id: '408', lat: 20.75, lon: 118.25, name: '南海东北部' },
    { id: '409', lat: 20.75, lon: 118.75, name: '南海东北部' },
    { id: '410', lat: 20.75, lon: 119.25, name: '南海东北部' },
    { id: '411', lat: 20.75, lon: 119.75, name: '南海东北部' },
    { id: '412', lat: 20.25, lon: 106.75, name: '北部湾' },
    { id: '413', lat: 20.25, lon: 107.25, name: '北部湾' },
    { id: '414', lat: 20.25, lon: 107.75, name: '北部湾' },
    { id: '415', lat: 20.25, lon: 108.25, name: '北部湾' },
    { id: '416', lat: 20.25, lon: 108.75, name: '北部湾' },
    { id: '417', lat: 20.25, lon: 109.25, name: '北部湾' },
    { id: '418', lat: 20.25, lon: 109.75, name: '南海西北部' },
    { id: '419', lat: 20.25, lon: 110.25, name: '南海西北部' },
    { id: '420', lat: 20.25, lon: 110.75, name: '南海西北部' },
    { id: '421', lat: 20.25, lon: 111.25, name: '南海西北部' },
    { id: '422', lat: 20.25, lon: 111.75, name: '南海西北部' },
    { id: '423', lat: 20.25, lon: 112.25, name: '南海西北部' },
    { id: '424', lat: 20.25, lon: 112.75, name: '南海西北部' },
    { id: '425', lat: 20.25, lon: 113.25, name: '南海西北部' },
    { id: '426', lat: 20.25, lon: 113.75, name: '南海西北部' },
    { id: '427', lat: 20.25, lon: 114.25, name: '南海西北部' },
    { id: '428', lat: 20.25, lon: 114.75, name: '南海东北部' },
    { id: '429', lat: 20.25, lon: 115.25, name: '南海东北部' },
    { id: '430', lat: 20.25, lon: 115.75, name: '南海东北部' },
    { id: '431', lat: 20.25, lon: 116.25, name: '南海东北部' },
    { id: '432', lat: 20.25, lon: 116.75, name: '南海东北部' },
    { id: '433', lat: 20.25, lon: 117.25, name: '南海东北部' },
    { id: '434', lat: 20.25, lon: 117.75, name: '南海东北部' },
    { id: '435', lat: 20.25, lon: 118.25, name: '南海东北部' },
    { id: '436', lat: 20.25, lon: 118.75, name: '南海东北部' },
    { id: '437', lat: 20.25, lon: 119.25, name: '南海东北部' },
    { id: '438', lat: 20.25, lon: 119.75, name: '南海东北部' },
    { id: '439', lat: 19.75, lon: 106.25, name: '北部湾' },
    { id: '440', lat: 19.75, lon: 106.75, name: '北部湾' },
    { id: '441', lat: 19.75, lon: 107.25, name: '北部湾' },
    { id: '442', lat: 19.75, lon: 107.75, name: '北部湾' },
    { id: '443', lat: 19.75, lon: 108.25, name: '北部湾' },
    { id: '444', lat: 19.75, lon: 108.75, name: '北部湾' },
    { id: '445', lat: 19.75, lon: 109.25, name: '北部湾' },
    { id: '446', lat: 19.75, lon: 111.25, name: '南海西北部' },
    { id: '447', lat: 19.75, lon: 111.75, name: '南海西北部' },
    { id: '448', lat: 19.75, lon: 112.25, name: '南海西北部' },
    { id: '449', lat: 19.75, lon: 112.75, name: '南海西北部' },
    { id: '450', lat: 19.75, lon: 113.25, name: '南海西北部' },
    { id: '451', lat: 19.75, lon: 113.75, name: '南海西北部' },
    { id: '452', lat: 19.75, lon: 114.25, name: '南海西北部' },
    { id: '453', lat: 19.75, lon: 114.75, name: '南海东北部' },
    { id: '454', lat: 19.75, lon: 115.25, name: '南海东北部' },
    { id: '455', lat: 19.75, lon: 115.75, name: '南海东北部' },
    { id: '456', lat: 19.75, lon: 116.25, name: '南海东北部' },
    { id: '457', lat: 19.75, lon: 116.75, name: '南海东北部' },
    { id: '458', lat: 19.75, lon: 117.25, name: '南海东北部' },
    { id: '459', lat: 19.75, lon: 117.75, name: '南海东北部' },
    { id: '460', lat: 19.75, lon: 118.25, name: '南海东北部' },
    { id: '461', lat: 19.75, lon: 118.75, name: '南海东北部' },
    { id: '462', lat: 19.75, lon: 119.25, name: '南海东北部' },
    { id: '463', lat: 19.25, lon: 106.25, name: '北部湾' },
    { id: '464', lat: 19.25, lon: 106.75, name: '北部湾' },
    { id: '465', lat: 19.25, lon: 107.25, name: '北部湾' },
    { id: '466', lat: 19.25, lon: 107.75, name: '北部湾' },
    { id: '467', lat: 19.25, lon: 108.25, name: '北部湾' },
    { id: '468', lat: 19.25, lon: 110.75, name: '南海中西北部' },
    { id: '469', lat: 19.25, lon: 111.25, name: '南海中西北部' },
    { id: '470', lat: 19.25, lon: 111.75, name: '南海中西北部' },
    { id: '471', lat: 19.25, lon: 112.25, name: '南海中西北部' },
    { id: '472', lat: 19.25, lon: 112.75, name: '南海中西北部' },
    { id: '473', lat: 19.25, lon: 113.25, name: '南海中西北部' },
    { id: '474', lat: 19.25, lon: 113.75, name: '南海中西北部' },
    { id: '475', lat: 19.25, lon: 114.25, name: '南海中西北部' },
    { id: '476', lat: 19.25, lon: 114.75, name: '南海中西北部' },
    { id: '477', lat: 19.25, lon: 115.25, name: '南海中西北部' },
    { id: '478', lat: 19.25, lon: 115.75, name: '南海中东部' },
    { id: '479', lat: 19.25, lon: 116.25, name: '南海中东部' },
    { id: '480', lat: 19.25, lon: 116.75, name: '南海中东部' },
    { id: '481', lat: 19.25, lon: 117.25, name: '南海中东部' },
    { id: '482', lat: 19.25, lon: 117.75, name: '南海中东部' },
    { id: '483', lat: 19.25, lon: 118.25, name: '南海中东部' },
    { id: '484', lat: 19.25, lon: 118.75, name: '南海中东部' },
    { id: '485', lat: 19.25, lon: 119.25, name: '南海中东部' },
    { id: '486', lat: 18.75, lon: 106.25, name: '北部湾' },
    { id: '487', lat: 18.75, lon: 106.75, name: '北部湾' },
    { id: '488', lat: 18.75, lon: 107.25, name: '北部湾' },
    { id: '489', lat: 18.75, lon: 107.75, name: '北部湾' },
    { id: '490', lat: 18.75, lon: 108.25, name: '北部湾' },
    { id: '491', lat: 18.75, lon: 110.25, name: '南海中西北部' },
    { id: '492', lat: 18.75, lon: 110.75, name: '南海中西北部' },
    { id: '493', lat: 18.75, lon: 111.25, name: '南海中西北部' },
    { id: '494', lat: 18.75, lon: 111.75, name: '南海中西北部' },
    { id: '495', lat: 18.75, lon: 112.25, name: '南海中西北部' },
    { id: '496', lat: 18.75, lon: 112.75, name: '南海中西北部' },
    { id: '497', lat: 18.75, lon: 113.25, name: '南海中西北部' },
    { id: '498', lat: 18.75, lon: 113.75, name: '南海中西北部' },
    { id: '499', lat: 18.75, lon: 114.25, name: '南海中西北部' },
    { id: '500', lat: 18.75, lon: 114.75, name: '南海中西北部' },
    { id: '501', lat: 18.75, lon: 115.25, name: '南海中西北部' },
    { id: '502', lat: 18.75, lon: 115.75, name: '南海中东部' },
    { id: '503', lat: 18.75, lon: 116.25, name: '南海中东部' },
    { id: '504', lat: 18.75, lon: 116.75, name: '南海中东部' },
    { id: '505', lat: 18.75, lon: 117.25, name: '南海中东部' },
    { id: '506', lat: 18.75, lon: 117.75, name: '南海中东部' },
    { id: '507', lat: 18.75, lon: 118.25, name: '南海中东部' },
    { id: '508', lat: 18.75, lon: 118.75, name: '南海中东部' },
    { id: '509', lat: 18.25, lon: 106.75, name: '北部湾' },
    { id: '510', lat: 18.25, lon: 107.25, name: '北部湾' },
    { id: '511', lat: 18.25, lon: 107.75, name: '北部湾' },
    { id: '512', lat: 18.25, lon: 108.25, name: '北部湾' },
    { id: '513', lat: 18.25, lon: 108.75, name: '北部湾' },
    { id: '514', lat: 18.25, lon: 109.25, name: '北部湾' },
    { id: '515', lat: 18.25, lon: 109.75, name: '北部湾' },
    { id: '516', lat: 18.25, lon: 110.25, name: '北部湾' },
    { id: '517', lat: 18.25, lon: 110.75, name: '南海中西北部' },
    { id: '518', lat: 18.25, lon: 111.25, name: '南海中西北部' },
    { id: '519', lat: 18.25, lon: 111.75, name: '南海中西北部' },
    { id: '520', lat: 18.25, lon: 112.25, name: '南海中西北部' },
    { id: '521', lat: 18.25, lon: 112.75, name: '南海中西北部' },
    { id: '522', lat: 18.25, lon: 113.25, name: '南海中西北部' },
    { id: '523', lat: 18.25, lon: 113.75, name: '南海中西北部' },
    { id: '524', lat: 18.25, lon: 114.25, name: '南海中西北部' },
    { id: '525', lat: 18.25, lon: 114.75, name: '南海中西北部' },
    { id: '526', lat: 18.25, lon: 115.25, name: '南海中西北部' },
    { id: '527', lat: 18.25, lon: 115.75, name: '南海中东部' },
    { id: '528', lat: 18.25, lon: 116.25, name: '南海中东部' },
    { id: '529', lat: 18.25, lon: 116.75, name: '南海中东部' },
    { id: '530', lat: 18.25, lon: 117.25, name: '南海中东部' },
    { id: '531', lat: 18.25, lon: 117.75, name: '南海中东部' },
    { id: '532', lat: 18.25, lon: 118.25, name: '南海中东部' },
    { id: '533', lat: 17.75, lon: 107.25, name: '北部湾' },
    { id: '534', lat: 17.75, lon: 107.75, name: '北部湾' },
    { id: '535', lat: 17.75, lon: 108.25, name: '北部湾' },
    { id: '536', lat: 17.75, lon: 108.75, name: '北部湾' },
    { id: '537', lat: 17.75, lon: 109.25, name: '北部湾' },
    { id: '538', lat: 17.75, lon: 109.75, name: '北部湾' },
    { id: '539', lat: 17.75, lon: 110.25, name: '北部湾' },
    { id: '540', lat: 17.75, lon: 110.75, name: '南海中西北部' },
    { id: '541', lat: 17.75, lon: 111.25, name: '南海中西北部' },
    { id: '542', lat: 17.75, lon: 111.75, name: '南海中西北部' },
    { id: '543', lat: 17.75, lon: 112.25, name: '南海中西北部' },
    { id: '544', lat: 17.75, lon: 112.75, name: '南海中西北部' },
    { id: '545', lat: 17.75, lon: 113.25, name: '南海中西北部' },
    { id: '546', lat: 17.75, lon: 113.75, name: '南海中西北部' },
    { id: '547', lat: 17.75, lon: 114.25, name: '南海中西北部' },
    { id: '548', lat: 17.75, lon: 114.75, name: '南海中西北部' },
    { id: '549', lat: 17.75, lon: 115.25, name: '南海中西北部' },
    { id: '550', lat: 17.75, lon: 115.75, name: '南海中东部' },
    { id: '551', lat: 17.75, lon: 116.25, name: '南海中东部' },
    { id: '552', lat: 17.75, lon: 116.75, name: '南海中东部' },
    { id: '553', lat: 17.75, lon: 117.25, name: '南海中东部' },
    { id: '554', lat: 17.75, lon: 117.75, name: '南海中东部' },
    { id: '555', lat: 17.25, lon: 107.75, name: '北部湾' },
    { id: '556', lat: 17.25, lon: 108.25, name: '北部湾' },
    { id: '557', lat: 17.25, lon: 108.75, name: '北部湾' },
    { id: '558', lat: 17.25, lon: 109.25, name: '北部湾' },
    { id: '559', lat: 17.25, lon: 109.75, name: '北部湾' },
    { id: '560', lat: 17.25, lon: 110.25, name: '北部湾' },
    { id: '561', lat: 17.25, lon: 110.75, name: '南海中西北部' },
    { id: '562', lat: 17.25, lon: 111.25, name: '南海中西北部' },
    { id: '563', lat: 17.25, lon: 111.75, name: '南海中西北部' },
    { id: '564', lat: 17.25, lon: 112.25, name: '南海中西北部' },
    { id: '565', lat: 17.25, lon: 112.75, name: '南海中西北部' },
    { id: '566', lat: 17.25, lon: 113.25, name: '南海中西北部' },
    { id: '567', lat: 17.25, lon: 113.75, name: '南海中西北部' },
    { id: '568', lat: 17.25, lon: 114.25, name: '南海中西北部' },
    { id: '569', lat: 17.25, lon: 114.75, name: '南海中西北部' },
    { id: '570', lat: 17.25, lon: 115.25, name: '南海中西北部' },
    { id: '571', lat: 17.25, lon: 115.75, name: '南海中东部' },
    { id: '572', lat: 17.25, lon: 116.25, name: '南海中东部' },
    { id: '573', lat: 17.25, lon: 116.75, name: '南海中东部' },
    { id: '574', lat: 17.25, lon: 117.25, name: '南海中东部' },
    { id: '575', lat: 17.25, lon: 117.75, name: '南海中东部' },
    { id: '576', lat: 17.25, lon: 118.25, name: '南海中东部' },
    { id: '577', lat: 17.25, lon: 118.75, name: '南海中东部' },
    { id: '578', lat: 16.75, lon: 109.25, name: '北部湾' },
    { id: '579', lat: 16.75, lon: 109.75, name: '北部湾' },
    { id: '580', lat: 16.75, lon: 110.25, name: '北部湾' },
    { id: '581', lat: 16.75, lon: 110.75, name: '南海中西北部' },
    { id: '582', lat: 16.75, lon: 111.25, name: '南海中西北部' },
    { id: '583', lat: 16.75, lon: 111.75, name: '南海中西北部' },
    { id: '584', lat: 16.75, lon: 112.25, name: '南海中西北部' },
    { id: '585', lat: 16.75, lon: 112.75, name: '南海中西北部' },
    { id: '586', lat: 16.75, lon: 113.25, name: '南海中西北部' },
    { id: '587', lat: 16.75, lon: 113.75, name: '南海中西北部' },
    { id: '588', lat: 16.75, lon: 114.25, name: '南海中西北部' },
    { id: '589', lat: 16.75, lon: 114.75, name: '南海中西北部' },
    { id: '590', lat: 16.75, lon: 115.25, name: '南海中西北部' },
    { id: '591', lat: 16.75, lon: 115.75, name: '南海中东部' },
    { id: '592', lat: 16.75, lon: 116.25, name: '南海中东部' },
    { id: '593', lat: 16.75, lon: 116.75, name: '南海中东部' },
    { id: '594', lat: 16.75, lon: 117.25, name: '南海中东部' },
    { id: '595', lat: 16.75, lon: 117.75, name: '南海中东部' },
    { id: '596', lat: 16.75, lon: 118.25, name: '南海中东部' },
    { id: '597', lat: 16.75, lon: 118.75, name: '南海中东部' },
    { id: '598', lat: 16.25, lon: 109.75, name: '北部湾' },
    { id: '599', lat: 16.25, lon: 110.25, name: '北部湾' },
    { id: '600', lat: 16.25, lon: 110.75, name: '南海中西北部' },
    { id: '601', lat: 16.25, lon: 111.25, name: '南海中西北部' },
    { id: '602', lat: 16.25, lon: 111.75, name: '南海中西北部' },
    { id: '603', lat: 16.25, lon: 112.25, name: '南海中西北部' },
    { id: '604', lat: 16.25, lon: 112.75, name: '南海中西北部' },
    { id: '605', lat: 16.25, lon: 113.25, name: '南海中西北部' },
    { id: '606', lat: 16.25, lon: 113.75, name: '南海中西北部' },
    { id: '607', lat: 16.25, lon: 114.25, name: '南海中西北部' },
    { id: '608', lat: 16.25, lon: 114.75, name: '南海中西北部' },
    { id: '609', lat: 16.25, lon: 115.25, name: '南海中西北部' },
    { id: '610', lat: 16.25, lon: 115.75, name: '南海中东部' },
    { id: '611', lat: 16.25, lon: 116.25, name: '南海中东部' },
    { id: '612', lat: 16.25, lon: 116.75, name: '南海中东部' },
    { id: '613', lat: 16.25, lon: 117.25, name: '南海中东部' },
    { id: '614', lat: 16.25, lon: 117.75, name: '南海中东部' },
    { id: '615', lat: 16.25, lon: 118.25, name: '南海中东部' },
    { id: '616', lat: 16.25, lon: 118.75, name: '南海中东部' },
    { id: '617', lat: 15.75, lon: 110.25, name: '北部湾' },
    { id: '618', lat: 15.75, lon: 110.75, name: '南海中西北部' },
    { id: '619', lat: 15.75, lon: 111.25, name: '南海中西北部' },
    { id: '620', lat: 15.75, lon: 111.75, name: '南海中西北部' },
    { id: '621', lat: 15.75, lon: 112.25, name: '南海中西北部' },
    { id: '622', lat: 15.75, lon: 112.75, name: '南海中西北部' },
    { id: '623', lat: 15.75, lon: 113.25, name: '南海中西北部' },
    { id: '624', lat: 15.75, lon: 113.75, name: '南海中西北部' },
    { id: '625', lat: 15.75, lon: 114.25, name: '南海中西北部' },
    { id: '626', lat: 15.75, lon: 114.75, name: '南海中西北部' },
    { id: '627', lat: 15.75, lon: 115.25, name: '南海中西北部' },
    { id: '628', lat: 15.75, lon: 115.75, name: '南海中东部' },
    { id: '629', lat: 15.75, lon: 116.25, name: '南海中东部' },
    { id: '630', lat: 15.75, lon: 116.75, name: '南海中东部' },
    { id: '631', lat: 15.75, lon: 117.25, name: '南海中东部' },
    { id: '632', lat: 15.75, lon: 117.75, name: '南海中东部' },
    { id: '633', lat: 15.75, lon: 118.25, name: '南海中东部' },
    { id: '634', lat: 15.75, lon: 118.75, name: '南海中东部' },
    { id: '635', lat: 15.25, lon: 110.75, name: '南海中西北部' },
    { id: '636', lat: 15.25, lon: 111.25, name: '南海中西北部' },
    { id: '637', lat: 15.25, lon: 111.75, name: '南海中西北部' },
    { id: '638', lat: 15.25, lon: 112.25, name: '南海中西北部' },
    { id: '639', lat: 15.25, lon: 112.75, name: '南海中西北部' },
    { id: '640', lat: 15.25, lon: 113.25, name: '南海中西北部' },
    { id: '641', lat: 15.25, lon: 113.75, name: '南海中西北部' },
    { id: '642', lat: 15.25, lon: 114.25, name: '南海中西北部' },
    { id: '643', lat: 15.25, lon: 114.75, name: '南海中西北部' },
    { id: '644', lat: 15.25, lon: 115.25, name: '南海中西北部' },
    { id: '645', lat: 15.25, lon: 115.75, name: '南海中东部' },
    { id: '646', lat: 15.25, lon: 116.25, name: '南海中东部' },
    { id: '647', lat: 15.25, lon: 116.75, name: '南海中东部' },
    { id: '648', lat: 15.25, lon: 117.25, name: '南海中东部' },
    { id: '649', lat: 15.25, lon: 117.75, name: '南海中东部' },
    { id: '650', lat: 15.25, lon: 118.25, name: '南海中东部' },
    { id: '651', lat: 15.25, lon: 118.75, name: '南海中东部' },
    { id: '652', lat: 14.75, lon: 110.75, name: '南海中西北部' },
    { id: '653', lat: 14.75, lon: 111.25, name: '南海中西北部' },
    { id: '654', lat: 14.75, lon: 111.75, name: '南海中西北部' },
    { id: '655', lat: 14.75, lon: 112.25, name: '南海中西北部' },
    { id: '656', lat: 14.75, lon: 112.75, name: '南海中西北部' },
    { id: '657', lat: 14.75, lon: 113.25, name: '南海中西北部' },
    { id: '658', lat: 14.75, lon: 113.75, name: '南海中西北部' },
    { id: '659', lat: 14.75, lon: 114.25, name: '南海中西北部' },
    { id: '660', lat: 14.75, lon: 114.75, name: '南海中西北部' },
    { id: '661', lat: 14.75, lon: 115.25, name: '南海中西北部' },
    { id: '662', lat: 14.75, lon: 115.75, name: '南海中东部' },
    { id: '663', lat: 14.75, lon: 116.25, name: '南海中东部' },
    { id: '664', lat: 14.75, lon: 116.75, name: '南海中东部' },
    { id: '665', lat: 14.75, lon: 117.25, name: '南海中东部' },
    { id: '666', lat: 14.75, lon: 117.75, name: '南海中东部' },
    { id: '667', lat: 14.75, lon: 118.25, name: '南海中东部' },
    { id: '668', lat: 14.75, lon: 118.75, name: '南海中东部' },
    { id: '669', lat: 14.25, lon: 110.75, name: '南海西南部' },
    { id: '670', lat: 14.25, lon: 111.25, name: '南海西南部' },
    { id: '671', lat: 14.25, lon: 111.75, name: '南海西南部' },
    { id: '672', lat: 14.25, lon: 112.25, name: '南海西南部' },
    { id: '673', lat: 14.25, lon: 112.75, name: '南海西南部' },
    { id: '674', lat: 14.25, lon: 113.25, name: '南海西南部' },
    { id: '675', lat: 14.25, lon: 113.75, name: '南海西南部' },
    { id: '676', lat: 14.25, lon: 114.25, name: '南海西南部' },
    { id: '677', lat: 14.25, lon: 114.75, name: '南海东南部' },
    { id: '678', lat: 14.25, lon: 115.25, name: '南海东南部' },
    { id: '679', lat: 14.25, lon: 115.75, name: '南海东南部' },
    { id: '680', lat: 14.25, lon: 116.25, name: '南海东南部' },
    { id: '681', lat: 14.25, lon: 116.75, name: '南海东南部' },
    { id: '682', lat: 14.25, lon: 117.25, name: '南海东南部' },
    { id: '683', lat: 14.25, lon: 117.75, name: '南海东南部' },
    { id: '684', lat: 14.25, lon: 118.25, name: '南海东南部' },
    { id: '685', lat: 14.25, lon: 118.75, name: '南海东南部' },
    { id: '686', lat: 13.75, lon: 110.75, name: '南海西南部' },
    { id: '687', lat: 13.75, lon: 111.25, name: '南海西南部' },
    { id: '688', lat: 13.75, lon: 111.75, name: '南海西南部' },
    { id: '689', lat: 13.75, lon: 112.25, name: '南海西南部' },
    { id: '690', lat: 13.75, lon: 112.75, name: '南海西南部' },
    { id: '691', lat: 13.75, lon: 113.25, name: '南海西南部' },
    { id: '692', lat: 13.75, lon: 113.75, name: '南海西南部' },
    { id: '693', lat: 13.75, lon: 114.25, name: '南海西南部' },
    { id: '694', lat: 13.75, lon: 114.75, name: '南海东南部' },
    { id: '695', lat: 13.75, lon: 115.25, name: '南海东南部' },
    { id: '696', lat: 13.75, lon: 115.75, name: '南海东南部' },
    { id: '697', lat: 13.75, lon: 116.25, name: '南海东南部' },
    { id: '698', lat: 13.75, lon: 116.75, name: '南海东南部' },
    { id: '699', lat: 13.75, lon: 117.25, name: '南海东南部' },
    { id: '700', lat: 13.75, lon: 117.75, name: '南海东南部' },
    { id: '701', lat: 13.75, lon: 118.25, name: '南海东南部' },
    { id: '702', lat: 13.75, lon: 118.75, name: '南海东南部' },
    { id: '703', lat: 13.25, lon: 110.75, name: '南海西南部' },
    { id: '704', lat: 13.25, lon: 111.25, name: '南海西南部' },
    { id: '705', lat: 13.25, lon: 111.75, name: '南海西南部' },
    { id: '706', lat: 13.25, lon: 112.25, name: '南海西南部' },
    { id: '707', lat: 13.25, lon: 112.75, name: '南海西南部' },
    { id: '708', lat: 13.25, lon: 113.25, name: '南海西南部' },
    { id: '709', lat: 13.25, lon: 113.75, name: '南海西南部' },
    { id: '710', lat: 13.25, lon: 114.25, name: '南海西南部' },
    { id: '711', lat: 13.25, lon: 114.75, name: '南海东南部' },
    { id: '712', lat: 13.25, lon: 115.25, name: '南海东南部' },
    { id: '713', lat: 13.25, lon: 115.75, name: '南海东南部' },
    { id: '714', lat: 13.25, lon: 116.25, name: '南海东南部' },
    { id: '715', lat: 13.25, lon: 116.75, name: '南海东南部' },
    { id: '716', lat: 13.25, lon: 117.25, name: '南海东南部' },
    { id: '717', lat: 13.25, lon: 117.75, name: '南海东南部' },
    { id: '718', lat: 13.25, lon: 118.25, name: '南海东南部' },
    { id: '719', lat: 13.25, lon: 118.75, name: '南海东南部' },
    { id: '720', lat: 12.75, lon: 110.75, name: '南海西南部' },
    { id: '721', lat: 12.75, lon: 111.25, name: '南海西南部' },
    { id: '722', lat: 12.75, lon: 111.75, name: '南海西南部' },
    { id: '723', lat: 12.75, lon: 112.25, name: '南海西南部' },
    { id: '724', lat: 12.75, lon: 112.75, name: '南海西南部' },
    { id: '725', lat: 12.75, lon: 113.25, name: '南海西南部' },
    { id: '726', lat: 12.75, lon: 113.75, name: '南海西南部' },
    { id: '727', lat: 12.75, lon: 114.25, name: '南海西南部' },
    { id: '728', lat: 12.75, lon: 114.75, name: '南海东南部' },
    { id: '729', lat: 12.75, lon: 115.25, name: '南海东南部' },
    { id: '730', lat: 12.75, lon: 115.75, name: '南海东南部' },
    { id: '731', lat: 12.75, lon: 116.25, name: '南海东南部' },
    { id: '732', lat: 12.75, lon: 116.75, name: '南海东南部' },
    { id: '733', lat: 12.75, lon: 117.25, name: '南海东南部' },
    { id: '734', lat: 12.75, lon: 117.75, name: '南海东南部' },
    { id: '735', lat: 12.75, lon: 118.25, name: '南海东南部' },
    { id: '736', lat: 12.75, lon: 118.75, name: '南海东南部' },
    { id: '737', lat: 12.25, lon: 110.75, name: '南海西南部' },
    { id: '738', lat: 12.25, lon: 111.25, name: '南海西南部' },
    { id: '739', lat: 12.25, lon: 111.75, name: '南海西南部' },
    { id: '740', lat: 12.25, lon: 112.25, name: '南海西南部' },
    { id: '741', lat: 12.25, lon: 112.75, name: '南海西南部' },
    { id: '742', lat: 12.25, lon: 113.25, name: '南海西南部' },
    { id: '743', lat: 12.25, lon: 113.75, name: '南海西南部' },
    { id: '744', lat: 12.25, lon: 114.25, name: '南海西南部' },
    { id: '745', lat: 12.25, lon: 114.75, name: '南海东南部' },
    { id: '746', lat: 12.25, lon: 115.25, name: '南海东南部' },
    { id: '747', lat: 12.25, lon: 115.75, name: '南海东南部' },
    { id: '748', lat: 12.25, lon: 116.25, name: '南海东南部' },
    { id: '749', lat: 12.25, lon: 116.75, name: '南海东南部' },
    { id: '750', lat: 12.25, lon: 117.25, name: '南海东南部' },
    { id: '751', lat: 12.25, lon: 117.75, name: '南海东南部' },
    { id: '752', lat: 12.25, lon: 118.25, name: '南海东南部' },
    { id: '753', lat: 11.75, lon: 110.75, name: '南海西南部' },
    { id: '754', lat: 11.75, lon: 111.25, name: '南海西南部' },
    { id: '755', lat: 11.75, lon: 111.75, name: '南海西南部' },
    { id: '756', lat: 11.75, lon: 112.25, name: '南海西南部' },
    { id: '757', lat: 11.75, lon: 112.75, name: '南海西南部' },
    { id: '758', lat: 11.75, lon: 113.25, name: '南海西南部' },
    { id: '759', lat: 11.75, lon: 113.75, name: '南海西南部' },
    { id: '760', lat: 11.75, lon: 114.25, name: '南海西南部' },
    { id: '761', lat: 11.75, lon: 114.75, name: '南海东南部' },
    { id: '762', lat: 11.75, lon: 115.25, name: '南海东南部' },
    { id: '763', lat: 11.75, lon: 115.75, name: '南海东南部' },
    { id: '764', lat: 11.75, lon: 116.25, name: '南海东南部' },
    { id: '765', lat: 11.75, lon: 116.75, name: '南海东南部' },
    { id: '766', lat: 11.75, lon: 117.25, name: '南海东南部' },
    { id: '767', lat: 11.75, lon: 117.75, name: '南海东南部' },
    { id: '768', lat: 11.75, lon: 118.25, name: '南海东南部' },
    { id: '769', lat: 11.25, lon: 110.75, name: '南海西南部' },
    { id: '770', lat: 11.25, lon: 111.25, name: '南海西南部' },
    { id: '771', lat: 11.25, lon: 111.75, name: '南海西南部' },
    { id: '772', lat: 11.25, lon: 112.25, name: '南海西南部' },
    { id: '773', lat: 11.25, lon: 112.75, name: '南海西南部' },
    { id: '774', lat: 11.25, lon: 113.25, name: '南海西南部' },
    { id: '775', lat: 11.25, lon: 113.75, name: '南海西南部' },
    { id: '776', lat: 11.25, lon: 114.25, name: '南海西南部' },
    { id: '777', lat: 11.25, lon: 114.75, name: '南海东南部' },
    { id: '778', lat: 11.25, lon: 115.25, name: '南海东南部' },
    { id: '779', lat: 11.25, lon: 115.75, name: '南海东南部' },
    { id: '780', lat: 11.25, lon: 116.25, name: '南海东南部' },
    { id: '781', lat: 11.25, lon: 116.75, name: '南海东南部' },
    { id: '782', lat: 11.25, lon: 117.25, name: '南海东南部' },
    { id: '783', lat: 11.25, lon: 117.75, name: '南海东南部' },
    { id: '784', lat: 10.75, lon: 110.75, name: '南海西南部' },
    { id: '785', lat: 10.75, lon: 111.25, name: '南海西南部' },
    { id: '786', lat: 10.75, lon: 111.75, name: '南海西南部' },
    { id: '787', lat: 10.75, lon: 112.25, name: '南海西南部' },
    { id: '788', lat: 10.75, lon: 112.75, name: '南海西南部' },
    { id: '789', lat: 10.75, lon: 113.25, name: '南海西南部' },
    { id: '790', lat: 10.75, lon: 113.75, name: '南海西南部' },
    { id: '791', lat: 10.75, lon: 114.25, name: '南海西南部' },
    { id: '792', lat: 10.75, lon: 114.75, name: '南海东南部' },
    { id: '793', lat: 10.75, lon: 115.25, name: '南海东南部' },
    { id: '794', lat: 10.75, lon: 115.75, name: '南海东南部' },
    { id: '795', lat: 10.75, lon: 116.25, name: '南海东南部' },
    { id: '796', lat: 10.75, lon: 116.75, name: '南海东南部' },
    { id: '797', lat: 10.75, lon: 117.25, name: '南海东南部' },
    { id: '798', lat: 10.75, lon: 117.75, name: '南海东南部' },
    { id: '799', lat: 10.25, lon: 110.75, name: '南海西南部' },
    { id: '800', lat: 10.25, lon: 111.25, name: '南海西南部' },
    { id: '801', lat: 10.25, lon: 111.75, name: '南海西南部' },
    { id: '802', lat: 10.25, lon: 112.25, name: '南海西南部' },
    { id: '803', lat: 10.25, lon: 112.75, name: '南海西南部' },
    { id: '804', lat: 10.25, lon: 113.25, name: '南海西南部' },
    { id: '805', lat: 10.25, lon: 113.75, name: '南海西南部' },
    { id: '806', lat: 10.25, lon: 114.25, name: '南海西南部' },
    { id: '807', lat: 10.25, lon: 114.75, name: '南海东南部' },
    { id: '808', lat: 10.25, lon: 115.25, name: '南海东南部' },
    { id: '809', lat: 10.25, lon: 115.75, name: '南海东南部' },
    { id: '810', lat: 10.25, lon: 116.25, name: '南海东南部' },
    { id: '811', lat: 10.25, lon: 116.75, name: '南海东南部' },
    { id: '812', lat: 10.25, lon: 117.25, name: '南海东南部' },
    { id: '813', lat: 10.25, lon: 117.75, name: '南海东南部' },
    { id: '814', lat: 9.75, lon: 110.25, name: '南海西南部' },
    { id: '815', lat: 9.75, lon: 110.75, name: '南海西南部' },
    { id: '816', lat: 9.75, lon: 111.25, name: '南海西南部' },
    { id: '817', lat: 9.75, lon: 111.75, name: '南海西南部' },
    { id: '818', lat: 9.75, lon: 112.25, name: '南海西南部' },
    { id: '819', lat: 9.75, lon: 112.75, name: '南海西南部' },
    { id: '820', lat: 9.75, lon: 113.25, name: '南海西南部' },
    { id: '821', lat: 9.75, lon: 113.75, name: '南海西南部' },
    { id: '822', lat: 9.75, lon: 114.25, name: '南海西南部' },
    { id: '823', lat: 9.75, lon: 114.75, name: '南海东南部' },
    { id: '824', lat: 9.75, lon: 115.25, name: '南海东南部' },
    { id: '825', lat: 9.75, lon: 115.75, name: '南海东南部' },
    { id: '826', lat: 9.75, lon: 116.25, name: '南海东南部' },
    { id: '827', lat: 9.75, lon: 116.75, name: '南海东南部' },
    { id: '828', lat: 9.75, lon: 117.25, name: '南海东南部' },
    { id: '829', lat: 9.25, lon: 109.75, name: '南海西南部' },
    { id: '830', lat: 9.25, lon: 110.25, name: '南海西南部' },
    { id: '831', lat: 9.25, lon: 110.75, name: '南海西南部' },
    { id: '832', lat: 9.25, lon: 111.25, name: '南海西南部' },
    { id: '833', lat: 9.25, lon: 111.75, name: '南海西南部' },
    { id: '834', lat: 9.25, lon: 112.25, name: '南海西南部' },
    { id: '835', lat: 9.25, lon: 112.75, name: '南海西南部' },
    { id: '836', lat: 9.25, lon: 113.25, name: '南海西南部' },
    { id: '837', lat: 9.25, lon: 113.75, name: '南海西南部' },
    { id: '838', lat: 9.25, lon: 114.25, name: '南海西南部' },
    { id: '839', lat: 9.25, lon: 114.75, name: '南海东南部' },
    { id: '840', lat: 9.25, lon: 115.25, name: '南海东南部' },
    { id: '841', lat: 9.25, lon: 115.75, name: '南海东南部' },
    { id: '842', lat: 9.25, lon: 116.25, name: '南海东南部' },
    { id: '843', lat: 9.25, lon: 116.75, name: '南海东南部' },
    { id: '844', lat: 8.75, lon: 109.75, name: '南海西南部' },
    { id: '845', lat: 8.75, lon: 110.25, name: '南海西南部' },
    { id: '846', lat: 8.75, lon: 110.75, name: '南海西南部' },
    { id: '847', lat: 8.75, lon: 111.25, name: '南海西南部' },
    { id: '848', lat: 8.75, lon: 111.75, name: '南海西南部' },
    { id: '849', lat: 8.75, lon: 112.25, name: '南海西南部' },
    { id: '850', lat: 8.75, lon: 112.75, name: '南海西南部' },
    { id: '851', lat: 8.75, lon: 113.25, name: '南海西南部' },
    { id: '852', lat: 8.75, lon: 113.75, name: '南海西南部' },
    { id: '853', lat: 8.75, lon: 114.25, name: '南海西南部' },
    { id: '854', lat: 8.75, lon: 114.75, name: '南海东南部' },
    { id: '855', lat: 8.75, lon: 115.25, name: '南海东南部' },
    { id: '856', lat: 8.75, lon: 115.75, name: '南海东南部' },
    { id: '857', lat: 8.75, lon: 116.25, name: '南海东南部' },
    { id: '858', lat: 8.25, lon: 109.25, name: '南海西南部' },
    { id: '859', lat: 8.25, lon: 109.75, name: '南海西南部' },
    { id: '860', lat: 8.25, lon: 110.25, name: '南海西南部' },
    { id: '861', lat: 8.25, lon: 110.75, name: '南海西南部' },
    { id: '862', lat: 8.25, lon: 111.25, name: '南海西南部' },
    { id: '863', lat: 8.25, lon: 111.75, name: '南海西南部' },
    { id: '864', lat: 8.25, lon: 112.25, name: '南海西南部' },
    { id: '865', lat: 8.25, lon: 112.75, name: '南海西南部' },
    { id: '866', lat: 8.25, lon: 113.25, name: '南海西南部' },
    { id: '867', lat: 8.25, lon: 113.75, name: '南海西南部' },
    { id: '868', lat: 8.25, lon: 114.25, name: '南海西南部' },
    { id: '869', lat: 8.25, lon: 114.75, name: '南海东南部' },
    { id: '870', lat: 8.25, lon: 115.25, name: '南海东南部' },
    { id: '871', lat: 8.25, lon: 115.75, name: '南海东南部' },
    { id: '872', lat: 7.75, lon: 109.25, name: '南海西南部' },
    { id: '873', lat: 7.75, lon: 109.75, name: '南海西南部' },
    { id: '874', lat: 7.75, lon: 110.25, name: '南海西南部' },
    { id: '875', lat: 7.75, lon: 110.75, name: '南海西南部' },
    { id: '876', lat: 7.75, lon: 111.25, name: '南海西南部' },
    { id: '877', lat: 7.75, lon: 111.75, name: '南海西南部' },
    { id: '878', lat: 7.75, lon: 112.25, name: '南海西南部' },
    { id: '879', lat: 7.75, lon: 112.75, name: '南海西南部' },
    { id: '880', lat: 7.75, lon: 113.25, name: '南海西南部' },
    { id: '881', lat: 7.75, lon: 113.75, name: '南海西南部' },
    { id: '882', lat: 7.75, lon: 114.25, name: '南海西南部' },
    { id: '883', lat: 7.75, lon: 114.75, name: '南海东南部' },
    { id: '884', lat: 7.75, lon: 115.25, name: '南海东南部' },
    { id: '885', lat: 7.25, lon: 109.25, name: '南海西南部' },
    { id: '886', lat: 7.25, lon: 109.75, name: '南海西南部' },
    { id: '887', lat: 7.25, lon: 110.25, name: '南海西南部' },
    { id: '888', lat: 7.25, lon: 110.75, name: '南海西南部' },
    { id: '889', lat: 7.25, lon: 111.25, name: '南海西南部' },
    { id: '890', lat: 7.25, lon: 111.75, name: '南海西南部' },
    { id: '891', lat: 7.25, lon: 112.25, name: '南海西南部' },
    { id: '892', lat: 7.25, lon: 112.75, name: '南海西南部' },
    { id: '893', lat: 7.25, lon: 113.25, name: '南海西南部' },
    { id: '894', lat: 7.25, lon: 113.75, name: '南海西南部' },
    { id: '895', lat: 7.25, lon: 114.25, name: '南海西南部' },
    { id: '896', lat: 7.25, lon: 114.75, name: '南海东南部' },
    { id: '897', lat: 7.25, lon: 115.25, name: '南海东南部' },
    { id: '898', lat: 6.75, lon: 109.25, name: '南海西南部' },
    { id: '899', lat: 6.75, lon: 109.75, name: '南海西南部' },
    { id: '900', lat: 6.75, lon: 110.25, name: '南海西南部' },
    { id: '901', lat: 6.75, lon: 110.75, name: '南海西南部' },
    { id: '902', lat: 6.75, lon: 111.25, name: '南海西南部' },
    { id: '903', lat: 6.75, lon: 111.75, name: '南海西南部' },
    { id: '904', lat: 6.75, lon: 112.25, name: '南海西南部' },
    { id: '905', lat: 6.75, lon: 112.75, name: '南海西南部' },
    { id: '906', lat: 6.75, lon: 113.25, name: '南海西南部' },
    { id: '907', lat: 6.75, lon: 113.75, name: '南海西南部' },
    { id: '908', lat: 6.75, lon: 114.25, name: '南海西南部' },
    { id: '909', lat: 6.75, lon: 114.75, name: '南海东南部' },
    { id: '910', lat: 6.25, lon: 109.75, name: '南海西南部' },
    { id: '911', lat: 6.25, lon: 110.25, name: '南海西南部' },
    { id: '912', lat: 6.25, lon: 110.75, name: '南海西南部' },
    { id: '913', lat: 6.25, lon: 111.25, name: '南海西南部' },
    { id: '914', lat: 6.25, lon: 111.75, name: '南海西南部' },
    { id: '915', lat: 6.25, lon: 112.25, name: '南海西南部' },
    { id: '916', lat: 6.25, lon: 112.75, name: '南海西南部' },
    { id: '917', lat: 6.25, lon: 113.25, name: '南海西南部' },
    { id: '918', lat: 6.25, lon: 113.75, name: '南海西南部' },
    { id: '919', lat: 6.25, lon: 114.25, name: '南海西南部' },
    { id: '920', lat: 5.75, lon: 110.25, name: '南海西南部' },
    { id: '921', lat: 5.75, lon: 110.75, name: '南海西南部' },
    { id: '922', lat: 5.75, lon: 111.25, name: '南海西南部' },
    { id: '923', lat: 5.75, lon: 111.75, name: '南海西南部' },
    { id: '924', lat: 5.75, lon: 112.25, name: '南海西南部' },
    { id: '925', lat: 5.75, lon: 112.75, name: '南海西南部' },
    { id: '926', lat: 5.75, lon: 113.25, name: '南海西南部' },
    { id: '927', lat: 5.75, lon: 113.75, name: '南海西南部' },
    { id: '928', lat: 5.75, lon: 114.25, name: '南海西南部' },
    { id: '929', lat: 5.25, lon: 110.75, name: '南海西南部' },
    { id: '930', lat: 5.25, lon: 111.25, name: '南海西南部' },
    { id: '931', lat: 5.25, lon: 111.75, name: '南海西南部' },
    { id: '932', lat: 5.25, lon: 112.25, name: '南海西南部' },
    { id: '933', lat: 5.25, lon: 112.75, name: '南海西南部' },
    { id: '934', lat: 5.25, lon: 113.25, name: '南海西南部' },
    { id: '935', lat: 4.75, lon: 111.25, name: '南海西南部' },
    { id: '936', lat: 4.75, lon: 111.75, name: '南海西南部' },
    { id: '937', lat: 4.75, lon: 112.25, name: '南海西南部' },
    { id: '938', lat: 4.75, lon: 112.75, name: '南海西南部' },
    { id: '939', lat: 4.75, lon: 113.25, name: '南海西南部' },
    { id: '940', lat: 4.25, lon: 111.25, name: '南海西南部' },
    { id: '941', lat: 4.25, lon: 111.75, name: '南海西南部' },
    { id: '942', lat: 4.25, lon: 112.25, name: '南海西南部' },
    { id: '943', lat: 4.25, lon: 112.75, name: '南海西南部' },
    { id: '944', lat: 3.75, lon: 111.75, name: '南海西南部' },
    { id: '945', lat: 3.75, lon: 112.25, name: '南海西南部' },
    { id: '7001', lat: 37.75, lon: 124.25, name: '黄海北部' },
    { id: '7002', lat: 37.75, lon: 124.75, name: '黄海北部' },
    { id: '7601', lat: 37.25, lon: 124.25, name: '黄海北部' },
    { id: '7602', lat: 37.25, lon: 124.75, name: '黄海北部' },
    { id: '8201', lat: 36.75, lon: 124.25, name: '黄海中部' },
    { id: '8202', lat: 36.75, lon: 124.75, name: '黄海中部' },
    { id: '8203', lat: 36.75, lon: 125.25, name: '黄海中部' },
    { id: '8901', lat: 36.25, lon: 124.25, name: '黄海中部' },
    { id: '8902', lat: 36.25, lon: 124.75, name: '黄海中部' },
    { id: '8903', lat: 36.25, lon: 125.25, name: '黄海中部' },
    { id: '9801', lat: 35.75, lon: 124.25, name: '黄海中部' },
    { id: '9802', lat: 35.75, lon: 124.75, name: '黄海中部' },
    { id: '9803', lat: 35.75, lon: 125.25, name: '黄海中部' },
    { id: '9804', lat: 35.75, lon: 125.75, name: '黄海中部' },
    { id: '1081', lat: 35.25, lon: 124.25, name: '黄海中部' },
    { id: '1082', lat: 35.25, lon: 124.75, name: '黄海中部' },
    { id: '1083', lat: 35.25, lon: 125.25, name: '黄海中部' },
    { id: '1084', lat: 35.25, lon: 125.75, name: '黄海中部' },
    { id: '1092', lat: 35.25, lon: 129.75, name: '东海东北部' },
    { id: '1093', lat: 35.25, lon: 130.25, name: '东海东北部' },
    { id: '1094', lat: 35.25, lon: 130.75, name: '' },
    { id: '1181', lat: 34.75, lon: 124.25, name: '黄海南部' },
    { id: '1182', lat: 34.75, lon: 124.75, name: '黄海南部' },
    { id: '1183', lat: 34.75, lon: 125.25, name: '黄海南部' },
    { id: '1184', lat: 34.75, lon: 125.75, name: '黄海南部' },
    { id: '1191', lat: 34.75, lon: 129.25, name: '东海东北部' },
    { id: '1192', lat: 34.75, lon: 129.75, name: '东海东北部' },
    { id: '1193', lat: 34.75, lon: 130.25, name: '东海东北部' },
    { id: '1194', lat: 34.75, lon: 130.75, name: '' },
    { id: '1261', lat: 34.25, lon: 124.25, name: '黄海南部' },
    { id: '1262', lat: 34.25, lon: 124.75, name: '黄海南部' },
    { id: '1263', lat: 34.25, lon: 125.25, name: '黄海南部' },
    { id: '1264', lat: 34.25, lon: 125.75, name: '东海东北部' },
    { id: '1269', lat: 34.25, lon: 128.25, name: '东海东北部' },
    { id: '1270', lat: 34.25, lon: 128.75, name: '东海东北部' },
    { id: '1272', lat: 34.25, lon: 129.75, name: '东海东北部' },
    { id: '1273', lat: 34.25, lon: 130.25, name: '东海东北部' },
    { id: '1351', lat: 33.75, lon: 125.25, name: '黄海南部' },
    { id: '1352', lat: 33.75, lon: 125.75, name: '东海东北部' },
    { id: '1354', lat: 33.75, lon: 126.75, name: '东海东北部' },
    { id: '1355', lat: 33.75, lon: 127.25, name: '东海东北部' },
    { id: '1356', lat: 33.75, lon: 127.75, name: '东海东北部' },
    { id: '1357', lat: 33.75, lon: 128.25, name: '东海东北部' },
    { id: '1358', lat: 33.75, lon: 128.75, name: '东海东北部' },
    { id: '1359', lat: 33.75, lon: 129.25, name: '东海东北部' },
    { id: '1441', lat: 33.25, lon: 125.25, name: '黄海南部' },
    { id: '1442', lat: 33.25, lon: 125.75, name: '东海东北部' },
    { id: '1445', lat: 33.25, lon: 127.25, name: '东海东北部' },
    { id: '1446', lat: 33.25, lon: 127.75, name: '东海东北部' },
    { id: '1447', lat: 33.25, lon: 128.25, name: '东海东北部' },
    { id: '1448', lat: 33.25, lon: 128.75, name: '东海东北部' },
    { id: '1521', lat: 32.75, lon: 125.25, name: '黄海南部' },
    { id: '1522', lat: 32.75, lon: 125.75, name: '东海东北部' },
    { id: '1523', lat: 32.75, lon: 126.25, name: '东海东北部' },
    { id: '1524', lat: 32.75, lon: 126.75, name: '东海东北部' },
    { id: '1525', lat: 32.75, lon: 127.25, name: '东海东北部' },
    { id: '1526', lat: 32.75, lon: 127.75, name: '东海东北部' },
    { id: '1527', lat: 32.75, lon: 128.25, name: '东海东北部' },
    { id: '1591', lat: 32.25, lon: 125.25, name: '东海西北部' },
    { id: '1592', lat: 32.25, lon: 125.75, name: '东海东北部' },
    { id: '1593', lat: 32.25, lon: 126.25, name: '东海东北部' },
    { id: '1594', lat: 32.25, lon: 126.75, name: '东海东北部' },
    { id: '1595', lat: 32.25, lon: 127.25, name: '东海东北部' },
    { id: '1596', lat: 32.25, lon: 127.75, name: '东海东北部' },
    { id: '1597', lat: 32.25, lon: 128.25, name: '东海东北部' },
    { id: '1598', lat: 32.25, lon: 128.75, name: '东海东北部' },
    { id: '1599', lat: 32.25, lon: 129.25, name: '东海东北部' },
    { id: '1661', lat: 31.75, lon: 125.25, name: '东海西北部' },
    { id: '1662', lat: 31.75, lon: 125.75, name: '东海东北部' },
    { id: '1663', lat: 31.75, lon: 126.25, name: '东海东北部' },
    { id: '1664', lat: 31.75, lon: 126.75, name: '东海东北部' },
    { id: '1665', lat: 31.75, lon: 127.25, name: '东海东北部' },
    { id: '1666', lat: 31.75, lon: 127.75, name: '东海东北部' },
    { id: '1667', lat: 31.75, lon: 128.25, name: '东海东北部' },
    { id: '1668', lat: 31.75, lon: 128.75, name: '东海东北部' },
    { id: '1669', lat: 31.75, lon: 129.25, name: '东海东北部' },
    { id: '1731', lat: 31.25, lon: 125.25, name: '东海西北部' },
    { id: '1732', lat: 31.25, lon: 125.75, name: '东海东北部' },
    { id: '1733', lat: 31.25, lon: 126.25, name: '东海东北部' },
    { id: '1734', lat: 31.25, lon: 126.75, name: '东海东北部' },
    { id: '1735', lat: 31.25, lon: 127.25, name: '东海东北部' },
    { id: '1736', lat: 31.25, lon: 127.75, name: '东海东北部' },
    { id: '1737', lat: 31.25, lon: 128.25, name: '东海东北部' },
    { id: '1738', lat: 31.25, lon: 128.75, name: '东海东北部' },
    { id: '1739', lat: 31.25, lon: 129.25, name: '东海东北部' },
    { id: '1811', lat: 30.75, lon: 125.25, name: '东海西北部' },
    { id: '1812', lat: 30.75, lon: 125.75, name: '东海东北部' },
    { id: '1813', lat: 30.75, lon: 126.25, name: '东海东北部' },
    { id: '1814', lat: 30.75, lon: 126.75, name: '东海东北部' },
    { id: '1815', lat: 30.75, lon: 127.25, name: '东海东北部' },
    { id: '1816', lat: 30.75, lon: 127.75, name: '东海东北部' },
    { id: '1817', lat: 30.75, lon: 128.25, name: '东海东北部' },
    { id: '1818', lat: 30.75, lon: 128.75, name: '东海东北部' },
    { id: '1819', lat: 30.75, lon: 129.25, name: '东海东北部' },
    { id: '1891', lat: 30.25, lon: 125.25, name: '东海西北部' },
    { id: '1892', lat: 30.25, lon: 125.75, name: '东海东北部' },
    { id: '1893', lat: 30.25, lon: 126.25, name: '东海东北部' },
    { id: '1894', lat: 30.25, lon: 126.75, name: '东海东北部' },
    { id: '1895', lat: 30.25, lon: 127.25, name: '东海东北部' },
    { id: '1896', lat: 30.25, lon: 127.75, name: '东海东北部' },
    { id: '1897', lat: 30.25, lon: 128.25, name: '东海东北部' },
    { id: '1898', lat: 30.25, lon: 128.75, name: '东海东北部' },
    { id: '1899', lat: 30.25, lon: 129.25, name: '东海东北部' },
    { id: '1951', lat: 29.75, lon: 125.25, name: '东海西北部' },
    { id: '1952', lat: 29.75, lon: 125.75, name: '东海东北部' },
    { id: '1953', lat: 29.75, lon: 126.25, name: '东海东北部' },
    { id: '1954', lat: 29.75, lon: 126.75, name: '东海东北部' },
    { id: '1955', lat: 29.75, lon: 127.25, name: '东海东北部' },
    { id: '1956', lat: 29.75, lon: 127.75, name: '东海东北部' },
    { id: '1957', lat: 29.75, lon: 128.25, name: '东海东北部' },
    { id: '1958', lat: 29.75, lon: 128.75, name: '东海东北部' },
    { id: '1959', lat: 29.75, lon: 129.25, name: '东海东北部' },
    { id: '2018', lat: 29.25, lon: 128.75, name: '东海东南部' },
    { id: '2011', lat: 29.25, lon: 125.25, name: '东海西南部' },
    { id: '2012', lat: 29.25, lon: 125.75, name: '东海东南部' },
    { id: '2013', lat: 29.25, lon: 126.25, name: '东海东南部' },
    { id: '2014', lat: 29.25, lon: 126.75, name: '东海东南部' },
    { id: '2015', lat: 29.25, lon: 127.25, name: '东海东南部' },
    { id: '2016', lat: 29.25, lon: 127.75, name: '东海东南部' },
    { id: '2017', lat: 29.25, lon: 128.25, name: '东海东南部' },
    { id: '2088', lat: 28.75, lon: 128.75, name: '东海东南部' },
    { id: '2081', lat: 28.75, lon: 125.25, name: '东海西南部' },
    { id: '2082', lat: 28.75, lon: 125.75, name: '东海东南部' },
    { id: '2083', lat: 28.75, lon: 126.25, name: '东海东南部' },
    { id: '2084', lat: 28.75, lon: 126.75, name: '东海东南部' },
    { id: '2085', lat: 28.75, lon: 127.25, name: '东海东南部' },
    { id: '2086', lat: 28.75, lon: 127.75, name: '东海东南部' },
    { id: '2087', lat: 28.75, lon: 128.25, name: '东海东南部' },
    { id: '2168', lat: 28.25, lon: 128.75, name: '东海东南部' },
    { id: '2161', lat: 28.25, lon: 125.25, name: '东海西南部' },
    { id: '2162', lat: 28.25, lon: 125.75, name: '东海东南部' },
    { id: '2163', lat: 28.25, lon: 126.25, name: '东海东南部' },
    { id: '2164', lat: 28.25, lon: 126.75, name: '东海东南部' },
    { id: '2165', lat: 28.25, lon: 127.25, name: '东海东南部' },
    { id: '2166', lat: 28.25, lon: 127.75, name: '东海东南部' },
    { id: '2167', lat: 28.25, lon: 128.25, name: '东海东南部' },
    { id: '2251', lat: 27.75, lon: 125.25, name: '东海西南部' },
    { id: '2252', lat: 27.75, lon: 125.75, name: '东海东南部' },
    { id: '2253', lat: 27.75, lon: 126.25, name: '东海东南部' },
    { id: '2254', lat: 27.75, lon: 126.75, name: '东海东南部' },
    { id: '2255', lat: 27.75, lon: 127.25, name: '东海东南部' },
    { id: '2256', lat: 27.75, lon: 127.75, name: '东海东南部' },
    { id: '2257', lat: 27.75, lon: 128.25, name: '东海东南部' },
    { id: '2341', lat: 27.25, lon: 125.25, name: '台湾以东洋面' },
    { id: '2342', lat: 27.25, lon: 125.75, name: '东海东南部' },
    { id: '2343', lat: 27.25, lon: 126.25, name: '东海东南部' },
    { id: '2344', lat: 27.25, lon: 126.75, name: '东海东南部' },
    { id: '2345', lat: 27.25, lon: 127.25, name: '东海东南部' },
    { id: '2346', lat: 27.25, lon: 127.75, name: '东海东南部' },
    { id: '2431', lat: 26.75, lon: 124.75, name: '台湾以东洋面' },
    { id: '2432', lat: 26.75, lon: 125.25, name: '台湾以东洋面' },
    { id: '2433', lat: 26.75, lon: 125.75, name: '东海东南部' },
    { id: '2434', lat: 26.75, lon: 126.25, name: '东海东南部' },
    { id: '2435', lat: 26.75, lon: 126.75, name: '东海东南部' },
    { id: '2436', lat: 26.75, lon: 127.25, name: '东海东南部' },
    { id: '2531', lat: 26.25, lon: 124.75, name: '台湾以东洋面' },
    { id: '2532', lat: 26.25, lon: 125.25, name: '台湾以东洋面' },
    { id: '2533', lat: 26.25, lon: 125.75, name: '东海东南部' },
    { id: '2534', lat: 26.25, lon: 126.25, name: '东海东南部' },
    { id: '2621', lat: 25.75, lon: 124.25, name: '台湾以东洋面' },
    { id: '2622', lat: 25.75, lon: 124.75, name: '台湾以东洋面' },
    { id: '2623', lat: 25.75, lon: 125.25, name: '台湾以东洋面' },
    { id: '2624', lat: 25.75, lon: 125.75, name: '东海东南部' },
    { id: '2721', lat: 25.25, lon: 124.25, name: '台湾以东洋面' },
    { id: '2722', lat: 25.25, lon: 124.75, name: '台湾以东洋面' },
    { id: '2723', lat: 25.25, lon: 125.25, name: '台湾以东洋面' },
    { id: '2724', lat: 25.25, lon: 125.75, name: '东海东南部' },
    { id: '21121C', lat: 21.25, lon: 121.25, name: '巴士海峡' },
    { id: '21121D', lat: 21.25, lon: 121.75, name: '巴士海峡' },
    { id: '20120A', lat: 20.75, lon: 120.25, name: '南海东北部' },
    { id: '20120B', lat: 20.75, lon: 120.75, name: '巴士海峡' },
    { id: '20121A', lat: 20.75, lon: 121.25, name: '巴士海峡' },
    { id: '20121B', lat: 20.75, lon: 121.75, name: '巴士海峡' },
    { id: '20120C', lat: 20.25, lon: 120.25, name: '南海东北部' },
    { id: '20120D', lat: 20.25, lon: 120.75, name: '巴士海峡' },
    { id: '20121C', lat: 20.25, lon: 121.25, name: '巴士海峡' },
    { id: '20121D', lat: 20.25, lon: 121.75, name: '巴士海峡' },
    { id: '19119B', lat: 19.75, lon: 119.75, name: '南海东北部' },
    { id: '19120A', lat: 19.75, lon: 120.25, name: '南海东北部' },
    { id: '19120B', lat: 19.75, lon: 120.75, name: '巴士海峡' },
    { id: '19121A', lat: 19.75, lon: 121.25, name: '巴士海峡' },
    { id: '19121B', lat: 19.75, lon: 121.75, name: '巴士海峡' },
    { id: '19119D', lat: 19.25, lon: 119.75, name: '南海中东部' },
    { id: '19120C', lat: 19.25, lon: 120.25, name: '南海中东部' },
    { id: '19120D', lat: 19.25, lon: 120.75, name: '巴士海峡' },
    { id: '19121C', lat: 19.25, lon: 121.25, name: '巴士海峡' },
    { id: '18119A', lat: 18.75, lon: 119.25, name: '南海中东部' },
    { id: '18119B', lat: 18.75, lon: 119.75, name: '南海中东部' },
    { id: '18120A', lat: 18.75, lon: 120.25, name: '南海中东部' },
    { id: '18120B', lat: 18.75, lon: 120.75, name: '巴士海峡' },
    { id: '18121A', lat: 18.75, lon: 121.25, name: '巴士海峡' },
    { id: '18106C', lat: 18.25, lon: 106.25, name: '北部湾' },
    { id: '18118D', lat: 18.25, lon: 118.75, name: '南海中东部' },
    { id: '18119C', lat: 18.25, lon: 119.25, name: '南海中东部' },
    { id: '18119D', lat: 18.25, lon: 119.75, name: '南海中东部' },
    { id: '18120C', lat: 18.25, lon: 120.25, name: '南海中东部' },
    { id: '17106B', lat: 17.75, lon: 106.75, name: '北部湾' },
    { id: '17118A', lat: 17.75, lon: 118.25, name: '南海中东部' },
    { id: '17118B', lat: 17.75, lon: 118.75, name: '南海中东部' },
    { id: '17119A', lat: 17.75, lon: 119.25, name: '南海中东部' },
    { id: '17119B', lat: 17.75, lon: 119.75, name: '南海中东部' },
    { id: '17120A', lat: 17.75, lon: 120.25, name: '南海中东部' },
    { id: '17107C', lat: 17.25, lon: 107.25, name: '北部湾' },
    { id: '17119C', lat: 17.25, lon: 119.25, name: '南海中东部' },
    { id: '17119D', lat: 17.25, lon: 119.75, name: '南海中东部' },
    { id: '17120C', lat: 17.25, lon: 120.25, name: '南海中东部' },
    { id: '16107B', lat: 16.75, lon: 107.75, name: '北部湾' },
    { id: '16108A', lat: 16.75, lon: 108.25, name: '北部湾' },
    { id: '16108B', lat: 16.75, lon: 108.75, name: '北部湾' },
    { id: '16119A', lat: 16.75, lon: 119.25, name: '南海中东部' },
    { id: '16119B', lat: 16.75, lon: 119.75, name: '南海中东部' },
    { id: '16108C', lat: 16.25, lon: 108.25, name: '北部湾' },
    { id: '16108D', lat: 16.25, lon: 108.75, name: '北部湾' },
    { id: '16109C', lat: 16.25, lon: 109.25, name: '北部湾' },
    { id: '16119C', lat: 16.25, lon: 119.25, name: '南海中东部' },
    { id: '16119D', lat: 16.25, lon: 119.75, name: '南海中东部' },
    { id: '15108B', lat: 15.75, lon: 108.75, name: '北部湾' },
    { id: '15109A', lat: 15.75, lon: 109.25, name: '北部湾' },
    { id: '15109B', lat: 15.75, lon: 109.75, name: '北部湾' },
    { id: '15119A', lat: 15.75, lon: 119.25, name: '南海中东部' },
    { id: '15119B', lat: 15.75, lon: 119.75, name: '南海中东部' },
    { id: '15109C', lat: 15.25, lon: 109.25, name: '北部湾' },
    { id: '15109D', lat: 15.25, lon: 109.75, name: '北部湾' },
    { id: '15110C', lat: 15.25, lon: 110.25, name: '北部湾' },
    { id: '15119C', lat: 15.25, lon: 119.25, name: '南海中东部' },
    { id: '15119D', lat: 15.25, lon: 119.75, name: '南海中东部' },
    { id: '14109A', lat: 14.75, lon: 109.25, name: '北部湾' },
    { id: '14109B', lat: 14.75, lon: 109.75, name: '北部湾' },
    { id: '14110A', lat: 14.75, lon: 110.25, name: '北部湾' },
    { id: '14119A', lat: 14.75, lon: 119.25, name: '南海中东部' },
    { id: '14119B', lat: 14.75, lon: 119.75, name: '南海中东部' },
    { id: '14109C', lat: 14.25, lon: 109.25, name: '' },
    { id: '14109D', lat: 14.25, lon: 109.75, name: '南海西南部' },
    { id: '14110C', lat: 14.25, lon: 110.25, name: '南海西南部' },
    { id: '14119C', lat: 14.25, lon: 119.25, name: '南海东南部' },
    { id: '14119D', lat: 14.25, lon: 119.75, name: '南海东南部' },
    { id: '14120C', lat: 14.25, lon: 120.25, name: '南海东南部' },
    { id: '13109B', lat: 13.75, lon: 109.75, name: '南海西南部' },
    { id: '13110A', lat: 13.75, lon: 110.25, name: '南海西南部' },
    { id: '13119A', lat: 13.75, lon: 119.25, name: '南海东南部' },
    { id: '13119B', lat: 13.75, lon: 119.75, name: '南海东南部' },
    { id: '13120A', lat: 13.75, lon: 120.25, name: '南海东南部' },
    { id: '13109D', lat: 13.25, lon: 109.75, name: '南海西南部' },
    { id: '13110C', lat: 13.25, lon: 110.25, name: '南海西南部' },
    { id: '13119C', lat: 13.25, lon: 119.25, name: '南海东南部' },
    { id: '13119D', lat: 13.25, lon: 119.75, name: '南海东南部' },
    { id: '13120C', lat: 13.25, lon: 120.25, name: '南海东南部' },
    { id: '12109B', lat: 12.75, lon: 109.75, name: '南海西南部' },
    { id: '12110A', lat: 12.75, lon: 110.25, name: '南海西南部' },
    { id: '12119A', lat: 12.75, lon: 119.25, name: '南海东南部' },
    { id: '12119B', lat: 12.75, lon: 119.75, name: '南海东南部' },
    { id: '12120A', lat: 12.75, lon: 120.25, name: '南海东南部' },
    { id: '12120B', lat: 12.75, lon: 120.75, name: '' },
    { id: '12109D', lat: 12.25, lon: 109.75, name: '南海西南部' },
    { id: '12110C', lat: 12.25, lon: 110.25, name: '南海西南部' },
    { id: '12118D', lat: 12.25, lon: 118.75, name: '南海东南部' },
    { id: '12119C', lat: 12.25, lon: 119.25, name: '南海东南部' },
    { id: '12119D', lat: 12.25, lon: 119.75, name: '南海东南部' },
    { id: '12120C', lat: 12.25, lon: 120.25, name: '南海东南部' },
    { id: '12120D', lat: 12.25, lon: 120.75, name: '' },
    { id: '11109A', lat: 11.75, lon: 109.25, name: '' },
    { id: '11109B', lat: 11.75, lon: 109.75, name: '南海西南部' },
    { id: '11110A', lat: 11.75, lon: 110.25, name: '南海西南部' },
    { id: '1111BB', lat: 11.75, lon: 118.75, name: '南海东南部' },
    { id: '11119A', lat: 11.75, lon: 119.25, name: '南海东南部' },
    { id: '11119B', lat: 11.75, lon: 119.75, name: '南海东南部' },
    { id: '11120A', lat: 11.75, lon: 120.25, name: '' },
    { id: '11120B', lat: 11.75, lon: 120.75, name: '' },
    { id: '11121A', lat: 11.75, lon: 121.25, name: '' },
    { id: '11109C', lat: 11.25, lon: 109.25, name: '' },
    { id: '11109D', lat: 11.25, lon: 109.75, name: '南海西南部' },
    { id: '11110C', lat: 11.25, lon: 110.25, name: '南海西南部' },
    { id: '11118C', lat: 11.25, lon: 118.25, name: '南海东南部' },
    { id: '11118D', lat: 11.25, lon: 118.75, name: '南海东南部' },
    { id: '11119C', lat: 11.25, lon: 119.25, name: '南海东南部' },
    { id: '11119D', lat: 11.25, lon: 119.75, name: '' },
    { id: '11120C', lat: 11.25, lon: 120.25, name: '' },
    { id: '11120D', lat: 11.25, lon: 120.75, name: '' },
    { id: '11121C', lat: 11.25, lon: 121.25, name: '' },
    { id: '10108A', lat: 10.75, lon: 108.25, name: '' },
    { id: '10108B', lat: 10.75, lon: 108.75, name: '' },
    { id: '10109A', lat: 10.75, lon: 109.25, name: '' },
    { id: '10109B', lat: 10.75, lon: 109.75, name: '南海西南部' },
    { id: '10110A', lat: 10.75, lon: 110.25, name: '南海西南部' },
    { id: '10118A', lat: 10.75, lon: 118.25, name: '南海东南部' },
    { id: '10118B', lat: 10.75, lon: 118.75, name: '南海东南部' },
    { id: '10119B', lat: 10.75, lon: 119.75, name: '' },
    { id: '10120A', lat: 10.75, lon: 120.25, name: '' },
    { id: '10120B', lat: 10.75, lon: 120.75, name: '' },
    { id: '10121A', lat: 10.75, lon: 121.25, name: '' },
    { id: '10107C', lat: 10.25, lon: 107.25, name: '' },
    { id: '10107D', lat: 10.25, lon: 107.75, name: '' },
    { id: '10108C', lat: 10.25, lon: 108.25, name: '' },
    { id: '10108D', lat: 10.25, lon: 108.75, name: '' },
    { id: '10109C', lat: 10.25, lon: 109.25, name: '南海西南部' },
    { id: '10109D', lat: 10.25, lon: 109.75, name: '南海西南部' },
    { id: '10110C', lat: 10.25, lon: 110.25, name: '南海西南部' },
    { id: '10118C', lat: 10.25, lon: 118.25, name: '南海东南部' },
    { id: '10118D', lat: 10.25, lon: 118.75, name: '南海东南部' },
    { id: '10119D', lat: 10.25, lon: 119.75, name: '' },
    { id: '10120C', lat: 10.25, lon: 120.25, name: '' },
    { id: '10120D', lat: 10.25, lon: 120.75, name: '' },
    { id: '10121C', lat: 10.25, lon: 121.25, name: '' },
    { id: '09106B', lat: 9.75, lon: 106.75, name: '' },
    { id: '09107A', lat: 9.75, lon: 107.25, name: '' },
    { id: '09107B', lat: 9.75, lon: 107.75, name: '' },
    { id: '09108A', lat: 9.75, lon: 108.25, name: '' },
    { id: '09108B', lat: 9.75, lon: 108.75, name: '' },
    { id: '09109A', lat: 9.75, lon: 109.25, name: '南海西南部' },
    { id: '09109B', lat: 9.75, lon: 109.75, name: '南海西南部' },
    { id: '09117B', lat: 9.75, lon: 117.75, name: '南海东南部' },
    { id: '09118A', lat: 9.75, lon: 118.25, name: '南海东南部' },
    { id: '09119A', lat: 9.75, lon: 119.25, name: '' },
    { id: '09119B', lat: 9.75, lon: 119.75, name: '' },
    { id: '09120A', lat: 9.75, lon: 120.25, name: '' },
    { id: '09120B', lat: 9.75, lon: 120.75, name: '' },
    { id: '09106C', lat: 9.25, lon: 106.25, name: '' },
    { id: '09106D', lat: 9.25, lon: 106.75, name: '' },
    { id: '09107C', lat: 9.25, lon: 107.25, name: '' },
    { id: '09107D', lat: 9.25, lon: 107.75, name: '' },
    { id: '09108C', lat: 9.25, lon: 108.25, name: '' },
    { id: '09108D', lat: 9.25, lon: 108.75, name: '南海西南部' },
    { id: '09109C', lat: 9.25, lon: 109.25, name: '南海西南部' },
    { id: '09117C', lat: 9.25, lon: 117.25, name: '南海东南部' },
    { id: '08104A', lat: 8.75, lon: 104.25, name: '' },
    { id: '08104B', lat: 8.75, lon: 104.75, name: '' },
    { id: '08105A', lat: 8.75, lon: 105.25, name: '' },
    { id: '08105B', lat: 8.75, lon: 105.75, name: '' },
    { id: '08106A', lat: 8.75, lon: 106.25, name: '' },
    { id: '08106B', lat: 8.75, lon: 106.75, name: '' },
    { id: '08107A', lat: 8.75, lon: 107.25, name: '' },
    { id: '08107B', lat: 8.75, lon: 107.75, name: '' },
    { id: '08108A', lat: 8.75, lon: 108.25, name: '' },
    { id: '08108B', lat: 8.75, lon: 108.75, name: '南海西南部' },
    { id: '08109A', lat: 8.75, lon: 109.25, name: '南海西南部' },
    { id: '08116B', lat: 8.75, lon: 116.75, name: '南海东南部' },
    { id: '08117A', lat: 8.75, lon: 117.25, name: '南海东南部' },
    { id: '08104C', lat: 8.25, lon: 104.25, name: '' },
    { id: '08104D', lat: 8.25, lon: 104.75, name: '' },
    { id: '08105C', lat: 8.25, lon: 105.25, name: '' },
    { id: '08105D', lat: 8.25, lon: 105.75, name: '' },
    { id: '08106C', lat: 8.25, lon: 106.25, name: '' },
    { id: '08106D', lat: 8.25, lon: 106.75, name: '' },
    { id: '08107C', lat: 8.25, lon: 107.25, name: '' },
    { id: '08107D', lat: 8.25, lon: 107.75, name: '' },
    { id: '08108C', lat: 8.25, lon: 108.25, name: '南海西南部' },
    { id: '08108D', lat: 8.25, lon: 108.75, name: '南海西南部' },
    { id: '08116C', lat: 8.25, lon: 116.25, name: '南海东南部' },
    { id: '08116D', lat: 8.25, lon: 116.75, name: '南海东南部' },
    { id: '08117C', lat: 8.25, lon: 117.25, name: '南海东南部' },
    { id: '08117D', lat: 8.25, lon: 117.75, name: '' },
    { id: '07104A', lat: 7.75, lon: 104.25, name: '' },
    { id: '07104B', lat: 7.75, lon: 104.75, name: '' },
    { id: '07105A', lat: 7.75, lon: 105.25, name: '' },
    { id: '07105B', lat: 7.75, lon: 105.75, name: '' },
    { id: '07106A', lat: 7.75, lon: 106.25, name: '' },
    { id: '07106B', lat: 7.75, lon: 106.75, name: '' },
    { id: '07107A', lat: 7.75, lon: 107.25, name: '' },
    { id: '07107B', lat: 7.75, lon: 107.75, name: '' },
    { id: '07108A', lat: 7.75, lon: 108.25, name: '南海西南部' },
    { id: '07108B', lat: 7.75, lon: 108.75, name: '南海西南部' },
    { id: '07115B', lat: 7.75, lon: 115.75, name: '南海东南部' },
    { id: '07116A', lat: 7.75, lon: 116.25, name: '南海东南部' },
    { id: '07116B', lat: 7.75, lon: 116.75, name: '南海东南部' },
    { id: '07117A', lat: 7.75, lon: 117.25, name: '' },
    { id: '07117B', lat: 7.75, lon: 117.75, name: '' },
    { id: '07104C', lat: 7.25, lon: 104.25, name: '' },
    { id: '07104D', lat: 7.25, lon: 104.75, name: '' },
    { id: '07105C', lat: 7.25, lon: 105.25, name: '' },
    { id: '07105D', lat: 7.25, lon: 105.75, name: '' },
    { id: '07106C', lat: 7.25, lon: 106.25, name: '' },
    { id: '07106D', lat: 7.25, lon: 106.75, name: '' },
    { id: '07107C', lat: 7.25, lon: 107.25, name: '' },
    { id: '07107D', lat: 7.25, lon: 107.75, name: '南海西南部' },
    { id: '07108C', lat: 7.25, lon: 108.25, name: '南海西南部' },
    { id: '07108D', lat: 7.25, lon: 108.75, name: '南海西南部' },
    { id: '07115D', lat: 7.25, lon: 115.75, name: '南海东南部' },
    { id: '07116C', lat: 7.25, lon: 116.25, name: '南海东南部' },
    { id: '07116D', lat: 7.25, lon: 116.75, name: '' },
    { id: '07117C', lat: 7.25, lon: 117.25, name: '' },
    { id: '07117D', lat: 7.25, lon: 117.75, name: '' },
    { id: '06104A', lat: 6.75, lon: 104.25, name: '' },
    { id: '06104B', lat: 6.75, lon: 104.75, name: '' },
    { id: '06105A', lat: 6.75, lon: 105.25, name: '' },
    { id: '06105B', lat: 6.75, lon: 105.75, name: '' },
    { id: '06106A', lat: 6.75, lon: 106.25, name: '' },
    { id: '06106B', lat: 6.75, lon: 106.75, name: '' },
    { id: '06107A', lat: 6.75, lon: 107.25, name: '' },
    { id: '06107B', lat: 6.75, lon: 107.75, name: '南海西南部' },
    { id: '06108A', lat: 6.75, lon: 108.25, name: '南海西南部' },
    { id: '06108B', lat: 6.75, lon: 108.75, name: '南海西南部' },
    { id: '06115A', lat: 6.75, lon: 115.25, name: '南海东南部' },
    { id: '06115B', lat: 6.75, lon: 115.75, name: '南海东南部' },
    { id: '06104C', lat: 6.25, lon: 104.25, name: '' },
    { id: '06104D', lat: 6.25, lon: 104.75, name: '' },
    { id: '06105C', lat: 6.25, lon: 105.25, name: '' },
    { id: '06105D', lat: 6.25, lon: 105.75, name: '' },
    { id: '06106C', lat: 6.25, lon: 106.25, name: '' },
    { id: '06106D', lat: 6.25, lon: 106.75, name: '' },
    { id: '06107C', lat: 6.25, lon: 107.25, name: '' },
    { id: '06107D', lat: 6.25, lon: 107.75, name: '南海西南部' },
    { id: '06108C', lat: 6.25, lon: 108.25, name: '南海西南部' },
    { id: '06108D', lat: 6.25, lon: 108.75, name: '南海西南部' },
    { id: '06109C', lat: 6.25, lon: 109.25, name: '南海西南部' },
    { id: '06114D', lat: 6.25, lon: 114.75, name: '南???东南部' },
    { id: '06115C', lat: 6.25, lon: 115.25, name: '南海东南部' },
    { id: '06115D', lat: 6.25, lon: 115.75, name: '南海东南部' },
    { id: '05104A', lat: 5.75, lon: 104.25, name: '' },
    { id: '05104B', lat: 5.75, lon: 104.75, name: '' },
    { id: '05105A', lat: 5.75, lon: 105.25, name: '' },
    { id: '05105B', lat: 5.75, lon: 105.75, name: '' },
    { id: '05106A', lat: 5.75, lon: 106.25, name: '' },
    { id: '05106B', lat: 5.75, lon: 106.75, name: '' },
    { id: '05107A', lat: 5.75, lon: 107.25, name: '' },
    { id: '05107B', lat: 5.75, lon: 107.75, name: '南海西南部' },
    { id: '05108A', lat: 5.75, lon: 108.25, name: '南海西南部' },
    { id: '05108B', lat: 5.75, lon: 108.75, name: '南海西南部' },
    { id: '05109A', lat: 5.75, lon: 109.25, name: '南海西南部' },
    { id: '05109B', lat: 5.75, lon: 109.75, name: '南海西南部' },
    { id: '05114B', lat: 5.75, lon: 114.75, name: '南海东南部' },
    { id: '05115A', lat: 5.75, lon: 115.25, name: '南海东南部' },
    { id: '05115B', lat: 5.75, lon: 115.75, name: '' },
    { id: '05104C', lat: 5.25, lon: 104.25, name: '' },
    { id: '05104D', lat: 5.25, lon: 104.75, name: '' },
    { id: '05105C', lat: 5.25, lon: 105.25, name: '' },
    { id: '05105D', lat: 5.25, lon: 105.75, name: '' },
    { id: '05106C', lat: 5.25, lon: 106.25, name: '' },
    { id: '05106D', lat: 5.25, lon: 106.75, name: '' },
    { id: '05107C', lat: 5.25, lon: 107.25, name: '' },
    { id: '05107D', lat: 5.25, lon: 107.75, name: '' },
    { id: '05108C', lat: 5.25, lon: 108.25, name: '南海西南部' },
    { id: '05108D', lat: 5.25, lon: 108.75, name: '南海西南部' },
    { id: '05109C', lat: 5.25, lon: 109.25, name: '南海西南部' },
    { id: '05109D', lat: 5.25, lon: 109.75, name: '南海西南部' },
    { id: '05110C', lat: 5.25, lon: 110.25, name: '南海西南部' },
    { id: '05113D', lat: 5.25, lon: 113.75, name: '南海西南部' },
    { id: '05114C', lat: 5.25, lon: 114.25, name: '南海西南部' },
    { id: '05114D', lat: 5.25, lon: 114.75, name: '南海西南部' },
    { id: '05115C', lat: 5.25, lon: 115.25, name: '' },
    { id: '04104A', lat: 4.75, lon: 104.25, name: '' },
    { id: '04104B', lat: 4.75, lon: 104.75, name: '' },
    { id: '04105A', lat: 4.75, lon: 105.25, name: '' },
    { id: '04105B', lat: 4.75, lon: 105.75, name: '' },
    { id: '04106A', lat: 4.75, lon: 106.25, name: '' },
    { id: '04106B', lat: 4.75, lon: 106.75, name: '' },
    { id: '04107A', lat: 4.75, lon: 107.25, name: '' },
    { id: '04107B', lat: 4.75, lon: 107.75, name: '' },
    { id: '04108A', lat: 4.75, lon: 108.25, name: '南海西南部' },
    { id: '04108B', lat: 4.75, lon: 108.75, name: '南海西南部' },
    { id: '04109A', lat: 4.75, lon: 109.25, name: '南海西南部' },
    { id: '04109B', lat: 4.75, lon: 109.75, name: '南海西南部' },
    { id: '04110A', lat: 4.75, lon: 110.25, name: '南海西南部' },
    { id: '04110B', lat: 4.75, lon: 110.75, name: '南海西南部' },
    { id: '04113B', lat: 4.75, lon: 113.75, name: '南海西南部' },
    { id: '04104C', lat: 4.25, lon: 104.25, name: '' },
    { id: '04104D', lat: 4.25, lon: 104.75, name: '' },
    { id: '04105C', lat: 4.25, lon: 105.25, name: '' },
    { id: '04105D', lat: 4.25, lon: 105.75, name: '' },
    { id: '04106C', lat: 4.25, lon: 106.25, name: '' },
    { id: '04106D', lat: 4.25, lon: 106.75, name: '' },
    { id: '04107C', lat: 4.25, lon: 107.25, name: '' },
    { id: '04107D', lat: 4.25, lon: 107.75, name: '' },
    { id: '04108C', lat: 4.25, lon: 108.25, name: '南海西南部' },
    { id: '04108D', lat: 4.25, lon: 108.75, name: '南海西南部' },
    { id: '04109C', lat: 4.25, lon: 109.25, name: '南海西南部' },
    { id: '04109D', lat: 4.25, lon: 109.75, name: '南海西南部' },
    { id: '04110C', lat: 4.25, lon: 110.25, name: '南海西南部' },
    { id: '04110D', lat: 4.25, lon: 110.75, name: '南海西南部' },
    { id: '04113C', lat: 4.25, lon: 113.25, name: '南海西南部' },
    { id: '04113D', lat: 4.25, lon: 113.75, name: '南海西南部' },
    { id: '03106B', lat: 3.75, lon: 106.75, name: '' },
    { id: '03107A', lat: 3.75, lon: 107.25, name: '' },
    { id: '03107B', lat: 3.75, lon: 107.75, name: '' },
    { id: '03108B', lat: 3.75, lon: 108.75, name: '' },
    { id: '03109A', lat: 3.75, lon: 109.25, name: '南海西南部' },
    { id: '03109B', lat: 3.75, lon: 109.75, name: '南海西南部' },
    { id: '03110A', lat: 3.75, lon: 110.25, name: '南海西南部' },
    { id: '03110B', lat: 3.75, lon: 110.75, name: '南海西南部' },
    { id: '03111A', lat: 3.75, lon: 111.25, name: '南海西南部' },
    { id: '03112B', lat: 3.75, lon: 112.75, name: '南海西南部' },
    { id: '03113A', lat: 3.75, lon: 113.25, name: '南海西南部' },
    { id: '03106D', lat: 3.25, lon: 106.75, name: '' },
    { id: '03107C', lat: 3.25, lon: 107.25, name: '' },
    { id: '03107D', lat: 3.25, lon: 107.75, name: '' },
    { id: '03108C', lat: 3.25, lon: 108.25, name: '' },
    { id: '03108D', lat: 3.25, lon: 108.75, name: '' },
    { id: '03109C', lat: 3.25, lon: 109.25, name: '' },
    { id: '03109D', lat: 3.25, lon: 109.75, name: '' },
    { id: '03110C', lat: 3.25, lon: 110.25, name: '南海西南部' },
    { id: '03110D', lat: 3.25, lon: 110.75, name: '南海西南部' },
    { id: '03111C', lat: 3.25, lon: 111.25, name: '南海西南部' },
    { id: '03111D', lat: 3.25, lon: 111.75, name: '南海西南部' },
    { id: '03112C', lat: 3.25, lon: 112.25, name: '南海西南部' },
    { id: '03112D', lat: 3.25, lon: 112.75, name: '' },
    { id: '02106A', lat: 2.75, lon: 106.75, name: '' },
    { id: '02107A', lat: 2.75, lon: 107.25, name: '' },
    { id: '02107B', lat: 2.75, lon: 107.75, name: '' },
    { id: '02108A', lat: 2.75, lon: 108.25, name: '' },
    { id: '02108B', lat: 2.75, lon: 108.75, name: '' },
    { id: '02109A', lat: 2.75, lon: 109.25, name: '' },
    { id: '02109B', lat: 2.75, lon: 109.75, name: '' },
    { id: '02110A', lat: 2.75, lon: 110.25, name: '' },
    { id: '02110B', lat: 2.75, lon: 110.75, name: '' },
    { id: '02111A', lat: 2.75, lon: 111.25, name: '' },
  ]
  private _tempAreaArray: L.Polygon[] = []
  private _zoomend = false

  constructor(map: MyMap, options?: Partial<AreaViewBaseOptions>) {
    super(map, options)
    this._data = this.data

    if (!this.isInit) this.init()
  }

  _show() {
    this.dispose = false
    const span = this.getSplitSpan()
    if (!lyGroup || (lyGroup && lyGroup._span !== span)) {
      this.clear()
      this.draw(span)
      this._Event.moveend()
    }
  }

  _hide() {
    this.clear()
    this.dispose = true
    this._map.off('zoomend', this._Event.zoomEnd)
    this._map.off('moveend', this._Event.moveend)
  }

  init() {
    this._map.setView([23.885837699862005, 118.91601562500001], 4)
    if (!lyGroup) lyGroup = L.layerGroup().addTo(this._map)
    this.polyNameChange()
  }

  clear(): void {
    if (lyGroup) {
      lyGroup.clearLayers()
      lyGroup._span = null
    }
    this.layerHash = {}
    for (const lyname in this.layerHashName) {
      this.layerHashName[lyname] &&
        this._map.removeLayer(this.layerHashName[lyname])
    }
    this.layerHashName = {}
  }

  draw(span = 1): void {
    if (this.dispose) return

    /**
     * 根据给定的中心点和半跨度，在地图上生成一个矩形网格的多边形数组。
     * @param p {LatLng} 中心点的经纬度坐标。
     * @param halfSpan {number} 矩形网格的半跨度，默认值为1。
     * @returns {LatLng[][]} 返回一个二维数组，每个数组元素代表一个矩形网格的四个角的经纬度坐标。
     */
    const divByPoint = (p: LatLng, halfSpan = 1): LatLng[][] => {
      const poly: LatLng[][] = []

      // 遍历生成矩形网格的x方向边界点
      for (let i = 0; i < halfSpan; i++) {
        // 遍历生成矩形网格的y方向边界点
        for (let j = 0; j < halfSpan; j++) {
          // 计算左上角点的坐标
          const left = L.latLng(
            p.lat - (i * this.span.y) / halfSpan,
            p.lng + (j * this.span.x) / halfSpan
          )
          // 生成并添加矩形网格的四个角的坐标到poly数组
          poly.push([
            left,
            L.latLng(left.lat, left.lng + this.span.x / halfSpan),
            L.latLng(
              left.lat - this.span.y / halfSpan,
              left.lng + this.span.x / halfSpan
            ),
            L.latLng(left.lat - this.span.y / halfSpan, left.lng),
          ])
        }
      }
      return poly
    }

    // draw
    this.data.forEach((c) => {
      // 调整点
      const p = L.latLng(c.lat + 0.25, c.lon - 0.25) // CanvasShipUtils.GPSEncryptByMapToLatLng(L.latLng(c.lat, c.lon), map);
      // 绘制以p点为左上点的跨度为 span 矩形
      const left = p.wrap()
      divByPoint(left, span).forEach((lls, i) => {
        const id = span > 1 ? [c.id, i + 1].join('-') : c.id
        this.layerHash[id] = L.polygon(lls, {
          weight: 1,
          opacity: 1,
          color: '#567a9d',
          fillOpacity: 0,
        })
        lyGroup?.addLayer(this.layerHash[id])
      })
    })

    if (lyGroup) lyGroup._span = this.getSplitSpan()
  }

  getSplitSpan(): number {
    const z = this._map.getZoom()
    return z > 0 && z <= 9 ? 1 : 3
  }

  showName(p: L.Layer, name?: string): any | null {
    name = name || ''
    const color = this._map.mapType !== 'MT_SATELLITE' ? '#333' : '#fff'
    if (this._map.getZoom() <= 6) return null
    return CommUtils.getFeatureLabel(p, name, {
      offset: 0,
      attributes: {
        fill: color,
        xShift: 0,
      },
    })
  }
  private _Event = {
    zoomEnd: throttle(() => {
      const span = this.getSplitSpan()
      if (!lyGroup || (lyGroup && lyGroup._span !== span)) {
        this.clear()
        this.draw(span)
      }
    }, 1000),
    moveend: throttle(() => {
      this._tempAreaArray = []

      for (const item in this.layerHash) {
        const ly = this.layerHashName[item]
        ly && this._map.removeLayer(ly)

        if (this.layerHash[item]) {
          this.layerHash[item] && this.layerHash[item].redraw()
          const lbounds = this.layerHash[item].getBounds()
          if (lbounds.isValid()) {
            if (this._map.getBounds().intersects(lbounds)) {
              this.layerHashName[item] = this.showName(
                this.layerHash[item],
                item
              )
              if (!this._zoomend)
                this.layerHashName[item] &&
                  this._map.addLayer(this.layerHashName[item])
              else {
                this._tempAreaArray.push(this.layerHashName[item])
              }
            }
          }
        }
      }

      // 延迟绘制
      // setTimeout(() => {
      // e.layerHashName[item] && map.addLayer(e.layerHashName[item])
      this._tempAreaArray.forEach((item) => {
        item && this._map.addLayer(item)
      })
      // }, 0)
      this._zoomend = !1
    }, 1000),
  }
  private polyNameChange(): void {
    this._map.off('zoomend', this._Event.zoomEnd)
    this._map.off('moveend', this._Event.moveend)
    this._map.on('zoomend', this._Event.zoomEnd)
    this._map.on('moveend', this._Event.moveend)
  }
}

// 实例化工厂方法
const fisheryManagerSymbol = (
  map: MyMap,
  options?: Partial<AreaViewBaseOptions>
) => {
  map.fisheryManagerSymbol =
    map.fisheryManagerSymbol || new FisheryManagerSymbol(map, options)
  return map.fisheryManagerSymbol
}

export { FisheryManagerSymbol, fisheryManagerSymbol }
